export function FIMHub(cjs, an) {
  var p; // shortcut to reference prototypes
  var lib = {};
  var ss = {};
  var img = {};
  lib.ssMetadata = [];

  (lib.AnMovieClip = function () {
    this.actionFrames = [];
    this.ignorePause = false;
    this.gotoAndPlay = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
    };
    this.play = function () {
      cjs.MovieClip.prototype.play.call(this);
    };
    this.gotoAndStop = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
    };
    this.stop = function () {
      cjs.MovieClip.prototype.stop.call(this);
    };
  }).prototype = p = new cjs.MovieClip();
  // symbols:
  // helper functions:

  function mc_symbol_clone() {
    var clone = this._cloneProps(
      new this.constructor(
        this.mode,
        this.startPosition,
        this.loop,
        this.reversed,
      ),
    );
    clone.gotoAndStop(this.currentFrame);
    clone.paused = this.paused;
    clone.framerate = this.framerate;
    return clone;
  }

  function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
    var prototype = cjs.extend(symbol, cjs.MovieClip);
    prototype.clone = mc_symbol_clone;
    prototype.nominalBounds = nominalBounds;
    prototype.frameBounds = frameBounds;
    return prototype;
  }

  (lib.star_silver = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 4
    this.shape = new cjs.Shape();
    this.shape.graphics
      .lf(['rgba(255,255,255,0)', '#FFFFFF'], [0, 1], 0.2, 18, 0, -17.9)
      .s()
      .p('AAABfIhuBMIAmiBIhrhRICHgEIAsh/IAtB/ICHAEIhsBRIAnCBg');
    this.shape.setTransform(0, -0.475);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // Layer 1
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .lf(['#999999', '#FFFFFF'], [0, 1], 0.5, 10.9, -0.4, -11)
      .s()
      .p('AABB4IiOBiIAxilIiJhoICsgEIA6iiIA5CiICsAEIiJBoIAxClg');
    this.shape_1.setTransform(0, -0.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

    // Layer 3
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .lf(['#CC0066', '#FF505A'], [0, 1], 0.1, 28.5, -0.1, -28.5)
      .s()
      .p('AAACdIi4CAIBAjYIiziIIDggFIBLjUIBLDUIDhAFIizCIIBADYg');
    this.shape_2.setTransform(0, -1.5);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-30, -30, 60, 57);

  (lib.star_gold = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .lf(['rgba(255,255,255,0)', '#FFFFFF'], [0, 1], 0.2, 17.9, 0, -18)
      .s()
      .p('AAABfIhuBLIAmiAIhrhRICHgEIAsh/IAtB/ICHAEIhsBRIAnCAg');
    this.shape.setTransform(0, -0.65);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // Layer 1
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .lf(['#FFFF22', '#F9BF34'], [0, 1], 0.5, 11, -0.4, -11)
      .s()
      .p('AABB5IiOBiIAxinIiJhnICsgFIA6iiIA5CiICsAFIiJBnIAxCng');
    this.shape_1.setTransform(0, -1.1);

    this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

    // Layer 3
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .lf(['#5645DA', '#3FB2FF'], [0, 1], 0, 22.2, 0, -22.2)
      .s()
      .p('AAACdIi4CAIBAjYIiziIIDggFIBLjUIBLDUIDhAFIizCIIBADYg');
    this.shape_2.setTransform(0, -1.5);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-30, -30, 60, 57);

  (lib.SkillSetBadge = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1),
    );

    // points
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AiFCaQgxg3AAhjQAAhjAxg2QAyg4BUAAQBWAAAwA4QAwA4AABgQAABjguA4QgvA4hXAAQhYAAgwg4gAgvhpQgPAcAABRQAABFAPAeQAQAeAgAAQAhAAAOgdQAPgfAAhRQAAhEgOgcQgPgcgigBQgfAAgQAcg',
      );
    this.shape.setTransform(21.925, 0.95);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f('#FFFFFF').s().p('Ag7DNIAAmZIB3AAIAAGZg');
    this.shape_1.setTransform(-17.975, 0.925);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AiyDPIAAgLQAyguA/hFQA/hGAQgcQAQgdAAgcQABgYgWgRQgUgRgeAAQg7AAhHAzIAAhWQBQgnBIAAQBOAAAvAfQAtAfAAA2QAABKiSCMICuAAIAABTg',
      );
    this.shape_2.setTransform(-17.5, 0.675);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AihC7IAAhQQA9AhA1AAQAlAAAXgPQAYgQAAgXQAAgZgXgQQgWgPgmgCIAAhHQAhAAAUgOQAUgPAAgTQAAgVgWgOQgUgNgiAAQgtAAg2AUIAAhIQA2gSBGAAQBMAAAwAcQAwAcAAAsQAAA9hQAiQBeAbAABNQAAA2g0AiQg0AghXAAQhHAAg9gXg',
      );
    this.shape_3.setTransform(-18.825, 0.95);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAbDPIAAhlIjRAAIAAhBID9j3IBMAAIAAD3IAkAAIAABBIgkAAIAABlgAhYApIBzAAIAAhvg',
      );
    this.shape_4.setTransform(-18.05, 0.675);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AiiC5IAAhKQA+AbA0gBQAmAAAXgQQAYgQAAgZQAAgbgdgQQgdgQg0AAQgdAAggAFIAAjoIEXAAIAABSIisAAIAABMQBWgEA0AkQA0AlABA4QAAA7g2AkQg1AkhZAAQhOAAg0gXg',
      );
    this.shape_5.setTransform(-18.25, 1.2);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AiBCqQgxgpAAhAQAAhFBJhbIBehyICEAAIh8CbQARgEASAAQA9AAArAjQArAjAAA6QAAA8gzAoQgzAohNAAQhPAAgygogAgqAcQgQARAAAdQAAAcAQAPQAQAQAcAAQAcAAARgQQARgRAAgcQgBgbgQgRQgRgRgcAAQgcAAgQARg',
      );
    this.shape_6.setTransform(-18.25, 0.95);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p('Ah8CwICRksIjHAAIAAhSIFlAAIAAAEIjDGag');
    this.shape_7.setTransform(-16.7, 1.2);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AiCCwQgygiAAg2QAAhHBRgbQhCggAAg4QAAgyAugfQAsgeBKAAQBMAAAuAhQAtAgAAAuQAAA6hCAeQBRAeAABEQAAA2gxAjQgzAhhRAAQhQAAgygigAgrAmQgQASAAAcQAAAfAQARQASASAaAAQAbAAAQgRQARgSAAgcQAAgegRgSQgQgSgcAAQgaAAgRARgAgkiGQgNAPAAAaQAAAbANAPQAOAPAXAAQAXAAANgPQANgQABgcQAAg2gzAAQgWAAgOAPg',
      );
    this.shape_8.setTransform(-17.75, 0.95);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [] })
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_2 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_3 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_4 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_7 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_8 }, { t: this.shape }] }, 1)
        .wait(1),
    );

    // bonus stickers
    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AG8BAIAAghQAIALAFAFQAGAEAHAAQALAAAAgOQAAgFgCgFQgDgEgIgGQgIgGgFgGQgFgEgEgJQgEgLAAgPQAAgTAIgMQAIgNANAAQAMAAAOAMIAAAeQgPgNgJAAQgFAAgDADQgDADAAAGQAAAFACAEQACAEAIAFQAJAHAFAGQAFAFADAJQAEAKAAAOQAAAWgIANQgIAMgNAAQgOAAgNgPgACSA4QgMgWAAghQAAghAMgXQANgXAUAAQAQAAALANIAAAjQgOgQgMAAQgMAAgHAOQgIANAAATQAAAVAHANQAIANAMAAQAGAAAFgDQAFgDALgLIAAAiQgOAPgQAAQgUAAgLgXgAguBAIAAghQAIALAFAFQAGAEAHAAQALAAAAgOQAAgFgCgFQgDgEgIgGQgIgGgFgGQgFgEgEgJQgEgLAAgPQAAgTAIgMQAIgNANAAQAMAAANAMIAAAeQgOgNgJAAQgFAAgDADQgDADAAAGQAAAFACAEQACAEAIAFQAJAHAFAGQAEAFADAJQAEAKAAAOQAAAWgIANQgHAMgNAAQgOAAgNgPgAiPBAIAAghQAIALAFAFQAGAEAHAAQALAAAAgOQAAgFgDgFQgCgEgIgGQgJgGgFgGQgEgEgEgJQgEgLAAgPQAAgTAIgMQAIgNANAAQAMAAANAMIAAAeQgOgNgKAAQgEAAgDADQgEADAAAGQAAAFADAEQACAEAIAFQAJAHAEAGQAGAFADAJQAEAKAAAOQAAAWgIANQgIAMgNAAQgOAAgNgPgAjfA+QgKgSAAghIAAhXIASAAIAABYQAAAQAGAKQAFAJAIAAQAJAAAFgJQAFgLAAgSIAAhVIATAAIAABWQAAAigKASQgKARgSAAQgRAAgKgRgAmdA4QgMgYAAgfQAAggAMgXQAMgYATAAQATAAAMAYQAMAXAAAgQAAAfgMAYQgMAXgTAAQgTAAgMgXgAmPghQgHANAAAVQAAAVAHANQAGAMALAAQALAAAGgMQAHgNAAgVQAAgVgHgNQgGgNgLAAQgLAAgGANgAGgBNIgGgdQgEgVgEgGQgDgHgDAAIgGAAIAAA/IgTAAIAAiZIAiAAQALAAAHANQAGANAAASQAAAagNALQAGAFAFAYIAKArgAGGgNIAKAAQAFAAACgEQADgFAAgIQAAgSgLAAIgJAAgAEtBNIAAiZIA3AAIAAAcIgkAAIAAAhIAjAAIAAAbIgjAAIAAAlIAlAAIAAAcgAEOBNIgdhIIAABIIgTAAIAAiZIATAAIAABGIAXhGIAVAAIgZBJIAiBQgABlBNIAAiZIATAAIAACZgAArBNIAAh9IgbAAIAAgcIBJAAIAAAcIgbAAIAAB9gAkJBNIgqhhIAABhIgSAAIAAiZIARAAIAoBeIAAheIATAAIAACZgAnzBNIAAiZIAgAAQAMAAAHALQAGAMAAAQQAAAUgKALQAIAEAEAJQAEALAAAOQAAAUgHAMQgGANgOAAgAngAxIAKAAQAIAAADgEQADgFAAgKQAAgIgDgEQgDgFgFAAIgNAAgAnggPIAKAAQAEAAADgEQACgFAAgIQAAgHgCgEQgDgFgEAAIgKAAg',
      );
    this.shape_9.setTransform(3.025, 34.975);
    this.shape_9._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape_9).wait(1).to({ _off: false }, 0).wait(8),
    );

    // shine
    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .lf(
        ['rgba(255,255,255,0)', 'rgba(255,255,255,0.498)'],
        [0, 1],
        3,
        10.3,
        3,
        -30.1,
      )
      .s()
      .p(
        'Ak4EpQhTAAg6g7Qg7g6AAhTIAAjBQAAhTA7g6QA6g7BTAAIJxAAQBTAAA6A7QA7A6AABTIAADBQAABTg7A6Qg6A7hTAAg',
      );
    this.shape_10.setTransform(1.733, -1.6163, 1.0582, 1.2384);
    this.shape_10._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape_10).wait(1).to({ _off: false }, 0).wait(8),
    );

    // star
    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('rgba(255,255,255,0.498)')
      .s()
      .p('AAAEAIk+DNIBulcIkzjdIGDgJICAlXICCFXIGDAJIk0DdIBuFcg');
    this.shape_11.setTransform(2.05, 7.1);
    this.shape_11._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape_11).wait(1).to({ _off: false }, 0).wait(8),
    );

    // border
    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .lf(
        [
          'rgba(0,0,0,0.2)',
          'rgba(0,0,0,0)',
          'rgba(255,255,255,0)',
          'rgba(255,255,255,0.694)',
        ],
        [0, 0.506, 0.522, 1],
        0,
        -53.9,
        0.1,
        53.9,
      )
      .s()
      .p(
        'AlCIAQhuAAhOhQQhPhQABhxIAAndQgBhxBPhQQBOhQBuAAIKFAAQBuAABOBQQBPBQAABxIAAHdQAABxhPBQQhOBQhuAAgAnemUQhIBMgBBqIAAG+QABBqBIBLQBKBLBnAAIJcAAQBnAABIhLQBKhLAAhqIAAm+QAAhqhKhMQhIhKhnAAIpcAAQhnAAhKBKg',
      );
    this.shape_12.setTransform(1.6, 8.975);
    this.shape_12._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape_12).wait(1).to({ _off: false }, 0).wait(8),
    );

    // bg
    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#0033CC')
      .s()
      .p(
        'AlqIyQh8AAhYhYQhYhYAAh8IAAoLQAAh8BYhYQBYhYB8AAILVAAQB8AABYBYQBYBYAAB8IAAILQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_13.setTransform(1.6148, 8.6732, 0.9413, 0.9652);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#6633CC')
      .s()
      .p(
        'AlqIyQh8AAhYhYQhYhYAAh8IAAoLQAAh8BYhYQBYhYB8AAILVAAQB8AABYBYQBYBYAAB8IAAILQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_14.setTransform(1.6148, 8.6732, 0.9413, 0.9652);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#9933CC')
      .s()
      .p(
        'AlqIyQh8AAhYhYQhYhYAAh8IAAoLQAAh8BYhYQBYhYB8AAILVAAQB8AABYBYQBYBYAAB8IAAILQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_15.setTransform(1.6148, 8.6732, 0.9413, 0.9652);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#990066')
      .s()
      .p(
        'AlqIyQh8AAhYhYQhYhYAAh8IAAoLQAAh8BYhYQBYhYB8AAILVAAQB8AABYBYQBYBYAAB8IAAILQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_16.setTransform(1.6148, 8.6732, 0.9413, 0.9652);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#FF3333')
      .s()
      .p(
        'AlqIyQh8AAhYhYQhYhYAAh8IAAoLQAAh8BYhYQBYhYB8AAILVAAQB8AABYBYQBYBYAAB8IAAILQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_17.setTransform(1.6148, 8.6732, 0.9413, 0.9652);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#FF6600')
      .s()
      .p(
        'AlqIyQh8AAhYhYQhYhYAAh8IAAoLQAAh8BYhYQBYhYB8AAILVAAQB8AABYBYQBYBYAAB8IAAILQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_18.setTransform(1.6148, 8.6732, 0.9413, 0.9652);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#FFCC00')
      .s()
      .p(
        'AlqIyQh8AAhYhYQhYhYAAh8IAAoLQAAh8BYhYQBYhYB8AAILVAAQB8AABYBYQBYBYAAB8IAAILQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_19.setTransform(1.6148, 8.6732, 0.9413, 0.9652);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#33CC00')
      .s()
      .p(
        'AlqIyQh8AAhYhYQhYhYAAh8IAAoLQAAh8BYhYQBYhYB8AAILVAAQB8AABYBYQBYBYAAB8IAAILQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_20.setTransform(1.6148, 8.6732, 0.9413, 0.9652);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [] })
        .to({ state: [{ t: this.shape_13 }] }, 1)
        .to({ state: [{ t: this.shape_14 }] }, 1)
        .to({ state: [{ t: this.shape_15 }] }, 1)
        .to({ state: [{ t: this.shape_16 }] }, 1)
        .to({ state: [{ t: this.shape_17 }] }, 1)
        .to({ state: [{ t: this.shape_18 }] }, 1)
        .to({ state: [{ t: this.shape_19 }] }, 1)
        .to({ state: [{ t: this.shape_20 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-60.8, -45.5, 124.8, 108.4);

  (lib.MainStage = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgQASQgHgHAAgLQAAgJAHgIQAHgGAJAAQALAAAHAHQAGAHAAALIggAAQAAAHAEADQAEAEAGAAQAIgBAJgGIAAAJQgIAGgMAAQgLAAgIgGgAgIgFIATAAQgBgJgJgBQgIABgBAJg',
      );
    this.shape.setTransform(48.975, -10.85);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgSAfQgGgEAAgGQAAgJAMgCQgFgDgBgEQAAgEAJgCQgGgBgEgDQgDgFAAgFQAAgGAFgGQAGgEAKAAIAaAAIAAAJIgHAAQACAEAAAEQAAAFgDAFQgEAEgIABIgIABIgBACQAAAAAAAAQAAAAAAABQABAAAAAAQAAAAABAAQABABAIABQAKABADAEQAEAFAAAEQAAAIgHADQgFAEgMABQgMAAgGgEgAgIARQgDABAAACQAAAGALAAQAFAAACgCQADgBAAgDQAAgFgKAAQgFAAgDACgAgGgXQgCADgBAEQABADACACQACADAEAAQADAAACgDQACgDAAgDQAAgEgCgCQgCgCgDAAQgEAAgCACg',
      );
    this.shape_1.setTransform(43.8, -9.7);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AADASQgGAGgIAAQgFAAgEgEQgEgDAAgFQAAgFAEgEQAEgDASgGQABgHgIgBQgJABgIAHIAAgLQAKgGAKAAQATAAAAAOIAAAUQAAABAAAAQAAABAAAAQABABAAAAQABAAAAAAQACAAAEgDIAAAIQgHAFgHAAQgHAAgBgGgAgGAFQgDACAAADQAAABAAAAQAAABAAAAQAAABABAAQAAABAAAAIADACQAFAAACgEIAAgMIgIAFg',
      );
    this.shape_2.setTransform(38.675, -10.85);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgHAaQgEgEAAgJIAAgSIgHAAIAAgDIASgWIACAAIAAAPIARAAIAAAKIgRAAIAAASQAAADACACQACACADAAQAFAAAFgDIAAALQgHADgGAAQgIAAgFgFg',
      );
    this.shape_3.setTransform(33.8, -11.525);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgQAUIAAgKQAJAEAGAAQAGAAAAgDIgBgCQgCgCgGgDQgIgDgCgCQgDgDAAgFQAAgGAFgEQAFgEAIAAQAIAAAHAEIAAAKQgIgGgHAAQgFABAAADIABACIAIAEQAHADADACQADAEAAAFQAAAHgFAEQgFAEgIAAQgJAAgHgEg',
      );
    this.shape_4.setTransform(29.725, -10.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAJAXIAAgaQAAgKgIAAQgEAAgFAIIAAAcIgOAAIAAgsIAOAAIAAAGQAHgHAHAAQAHgBAFAFQAFAFAAAIIAAAcg',
      );
    this.shape_5.setTransform(21.875, -10.9);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgGAiIAAgsIAOAAIAAAsgAgFgUQgCgDAAgDQAAgDACgCQADgDACAAQAEAAACADQACACAAADQAAADgCADQgCADgEgBQgCABgDgDg',
      );
    this.shape_6.setTransform(17.6, -12);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AADASQgGAGgIAAQgFAAgEgEQgEgDAAgFQAAgFAEgEQAEgDASgGQABgHgIgBQgJABgIAHIAAgLQAKgGAKAAQATAAAAAOIAAAUQAAABAAAAQAAABAAAAQABABAAAAQABAAAAAAQACAAAEgDIAAAIQgHAFgHAAQgHAAgBgGgAgGAFQgDACAAADQAAABAAAAQAAABAAAAQAAABABAAQAAABAAAAIADACQAFAAACgEIAAgMIgIAFg',
      );
    this.shape_7.setTransform(13.825, -10.85);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p('AAUAiIAAgpIgTAUIgBAAIgTgUIAAApIgRAAIAAhDIAPAAIAVAZIAWgZIAPAAIAABDg');
    this.shape_8.setTransform(6.575, -11.95);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.MainStage,
    new cjs.Rectangle(0.1, -21, 53.699999999999996, 17.8),
    null,
  );

  (lib.MainLabel = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(2),
    );

    // FlashAICB
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#424242')
      .s()
      .p(
        'AgIAWQgHgDgHgIIAAgDQACgDADABIABABQAFAFAFADQAIAEADgGQABgDgJgJQgLgIAEgIQAGgNAPAHQAFADAFAFQABAAAAABQABABAAAAQAAABAAAAQAAAAgBABQAAABAAAAQgBABAAAAQgBABgBgBQAAAAgBAAIgBgBIgJgGQgJgEgCAGQgCADAKAJQALAIgEAJQgCAFgGACIgDAAQgEAAgFgCg',
      );
    this.shape.setTransform(41.6851, -82.1526, 2.6923, 2.6923);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#424242')
      .s()
      .p(
        'AgFAbQgNgEAEgMIAJgZIgGgCIgBgCIABgBIAPgIIABAAQABAAAAAAQAAABABAAQAAAAAAAAQAAABgBAAIgCAHIAKADQABABAAAAQABAAAAABQAAAAAAABQAAABAAABQgBADgEgBIgJgEIgIAZQgCAFAGACIAEABQABABABAAQAAAAAAABQABAAAAABQAAABgBABQAAAAAAAAQAAABgBAAQAAAAgBAAQAAABgBAAIgGgBg',
      );
    this.shape_1.setTransform(33.6313, -86.5191, 2.6923, 2.6923);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#424242')
      .s()
      .p(
        'AgCAXQgLgCgFgHQgEgIACgKQACgKAHgFQAHgGAJACQAKACAEAIQAEAIgCAIQgBAEgEgBIgcgGQgCANAOADQAGACAGgCIABAAQAEABgBADQAAAAAAABQgBAAAAABQAAAAgBAAQAAABgBAAQgEABgEAAIgHgBgAgLgGIAZAGQACgNgMgDIgEAAQgIAAgDAKg',
      );
    this.shape_2.setTransform(21.6894, -88.7553, 2.6923, 2.6923);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#424242')
      .s()
      .p(
        'AAAAgQgKAAgLgGQAAAAgBAAQAAgBAAAAQgBgBAAAAQAAgBAAgBQABgDADAAIACAAQAFAEAMACQAPABAAgLQABgFgSgHQgTgFABgNQABgHAGgFQAHgFAKABQAJAAAJAEQABABAAAAQAAAAABABQAAAAAAABQAAAAAAABQAAAEgEgBIgBAAQgHgDgIgBQgOgBgBAKQgBAHASAHQASAFgBANQAAAHgHAFQgFADgIAAIgDAAg',
      );
    this.shape_3.setTransform(7.731, -93.1643, 2.6923, 2.6923);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#424242')
      .s()
      .p(
        'AgBAdIgFg4QABgFADAAQADgBABAFIAFA5QgBAEgEAAIgBAAQAAAAgBAAQAAAAAAgBQAAAAAAgBQgBgBAAgBg',
      );
    this.shape_4.setTransform(-8.4342, -93.5192, 2.6923, 2.6923);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#424242')
      .s()
      .p(
        'AAAAeIgHg5QAAgEADgBQAEgBAAAEIAIA6QABADgEABIgCAAQAAAAgBAAQAAAAgBgBQAAAAAAgBQgBgBAAAAg',
      );
    this.shape_5.setTransform(-14.5347, -92.8461, 2.6923, 2.6923);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#424242')
      .s()
      .p(
        'AAEAgQgBgBAAAAQAAAAgBgBQAAAAAAAAQAAgBAAAAIgHglQgBgEAEgBQADgBABAFIAIAkQABAEgFABIAAAAIgCAAgAgJgZIAAAAQgBgFAFgBIAAAAQAFgBAAAFIAAAAQABAFgEABIAAAAIgCAAQgDAAgBgEg',
      );
    this.shape_6.setTransform(-20.415, -91.6366, 2.6923, 2.6923);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#424242')
      .s()
      .p(
        'AgJAdIgRg3QgBgEAEgBQAEgCABAFIAKAiIAOgYIACgCQAEgBABAEQABAAAAAAQAAABAAAAQAAABgBAAQAAABAAAAIgJAOIAWAQIABACQABAEgEABIgDgBIgVgPIgFAJIAEALQABAEgEABIgCAAQgBAAAAAAQgBAAAAAAQgBgBAAAAQAAgBAAgBg',
      );
    this.shape_7.setTransform(-29.0977, -88.4711, 2.6923, 2.6923);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#424242')
      .s()
      .p(
        'AgLAgQgCgDAEgCIACAAQAHAAAJgEQAPgHgFgJQgCgFgSADQgUADgFgKQgDgHADgHQAEgIAKgFQAJgDAHgBQABAAAAAAQABAAAAAAQABABAAAAQAAAAABABQABADgDACIgBAAQgHABgGADQgPAHAEAJQADAGASgDQAUgEAFALQADAHgDAHQgEAHgKAEQgLAFgJAAQAAAAgBAAQgBAAAAAAQgBgBAAAAQAAgBgBAAg',
      );
    this.shape_8.setTransform(-42.2901, -84.298, 2.6923, 2.6923);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#424242')
      .s()
      .p(
        'AgOASQgGgFgEgIIABgEQADgBACABIABABQADAGAFAEQAHAHADgFQACgCgHgMQgIgLAGgHQAJgKANALQAFAEADAGQABABAAABQAAAAAAABQAAAAAAABQAAAAgBAAQgCADgDgCIgBgBIgGgIQgJgHgDAFQgCADAHAKQAIAMgGAHQgEAFgEAAQgHAAgGgGg',
      );
    this.shape_9.setTransform(62.3894, -70.4725, 2.6223, 2.6226);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#424242')
      .s()
      .p(
        'AgMAYQgLgIAHgJIAPgXIgFgDQAAgBAAAAQAAAAAAAAQgBgBABAAQAAAAAAAAIABgCIAQgDIACABQAAAAABABQAAAAAAAAQAAAAAAABQAAAAgBAAIgEAGIAJAGQADACgDADQAAABgBAAQAAABgBAAQAAAAgBgBQAAAAgBgBIgJgFIgOAVQgDAFAFADIAFACQAAABABABQAAAAAAABQAAAAAAABQAAAAgBABQAAAAAAABQAAAAgBAAQAAAAgBAAQAAAAgBAAg',
      );
    this.shape_10.setTransform(55.646, -76.6844, 2.6223, 2.6226);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#424242')
      .s()
      .p(
        'AgJAVQgJgFgDgJQgDgIAFgKQAFgJAJgDQAIgCAJAFQAHAEAEAGIAAAEQgBADgEgBIgBgCQgEgFgEgCQgHgEgFACQgGACgDAGQgIANAPAIQAEADAFAAIACAAQABABAAAAQABABAAAAQAAABAAABQAAAAAAABQAAAAgBABQAAAAAAAAQgBABAAAAQgBAAAAAAIgDAAQgGAAgFgDg',
      );
    this.shape_11.setTransform(46.1369, -81.5251, 2.6223, 2.6226);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#424242')
      .s()
      .p(
        'AAHAaQgEgCACgDIAAgDQgHAEgKgDQgGgDgCgEQgDgFACgGQAGgNASAIIAKADIAAAAQAEgLgLgEIgLgCIgBAAQgBgBAAAAQgBgBAAAAQAAgBAAAAQAAgBAAgBQAAAAAAgBQABAAAAgBQAAAAABAAQABAAAAAAQAHAAAIACQARAHgGAQIgJAXQAAABAAABQgBAAAAAAQgBABAAAAQgBAAAAAAIgCAAgAgNADQgCAHAJADQAGADAIgEIADgHIgKgEQgEgBgEAAQgFAAgBADg',
      );
    this.shape_12.setTransform(33.4214, -86.99, 2.6223, 2.6226);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#424242')
      .s()
      .p(
        'AgYAfQgDgBABgEIAMg1QABgEAFABIAhAJQADABAAADQgCAEgDgBIgdgHIgFATIAaAGQAEABgBADQgBAEgEgBIgagGIgFAXQgBABAAAAQAAABgBAAQAAABgBAAQAAAAgBAAIgCAAg',
      );
    this.shape_13.setTransform(24.0281, -93.7969, 2.6223, 2.6226);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#424242')
      .s()
      .p(
        'AgUAAQAAgJAFgHQAHgHAJAAQAKABAFAHQAGAGAAAJQgBAEgEAAIgdgBQABANANAAQAGABAHgDIABAAQAEABgBADQAAAAAAAAQAAABAAAAQAAABgBAAQAAAAgBABQgHADgJAAQgWgBABgXgAgMgDIAaABQAAgNgNgBQgMAAgBANg',
      );
    this.shape_14.setTransform(3.5746, -93.4732, 2.6223, 2.6226);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#424242')
      .s()
      .p(
        'AgRAdIgFg5QgBgEAEAAQAEgBABAFIACAXQAHgJAIgBQAIAAAEAEQAFAFABAGIACAZQABAFgFAAQgDAAgBgEIgCgYQgBgKgKABQgIAAgFAJIACAbQABAEgEAAIgBAAQgBAAgBAAQAAAAgBgBQAAAAAAgBQgBgBAAgBg',
      );
    this.shape_15.setTransform(-10.3235, -95.3049, 2.6223, 2.6226);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#424242')
      .s()
      .p(
        'AgEARIgGgaIgGACQgBAAAAAAQAAAAgBgBQAAAAAAAAQAAAAAAgBIABgBIAJgPIABgBQAAAAABAAQAAAAAAAAQABAAAAABQAAAAAAABIABAHIAJgDQAEgBABAEQAAABAAABQAAAAAAABQgBAAAAABQgBAAgBAAIgJACIAFAaQABAFAGgBIAFgCQABAAAAAAQABAAAAAAQABABAAAAQABABAAABQAAAAAAABQAAAAAAABQgBAAAAABQAAAAAAAAQgEADgDAAIgFABQgIAAgCgKg',
      );
    this.shape_16.setTransform(-21.3369, -92.5099, 2.6223, 2.6226);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#424242')
      .s()
      .p(
        'AgCASIgKgZIgGACQAAAAAAAAQgBAAAAAAQAAAAAAgBQgBAAAAAAIAAgCIAIgPIABgCIACABIADAHIAIgDQABgBAAAAQABAAAAABQABAAABAAQAAABABABQAAAAAAABQAAABAAAAQgBABAAAAQgBABAAAAIgJAEIAJAYQABAEAGgBIAFgDQAAAAABAAQABAAAAAAQABABAAAAQAAABABAAQAAABAAAAQAAABAAAAQAAABAAAAQgBABAAAAIgGAEIgHACQgHAAgCgIg',
      );
    this.shape_17.setTransform(-35.248, -88.3148, 2.6223, 2.6226);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#424242')
      .s()
      .p(
        'AgHAXQgCgDADgCIACAAQAHgBAEgCQAJgFgDgFQgBgDgNADQgOADgEgIQgHgMAQgIQAIgEAEAAQABAAAAAAQABAAAAAAQABAAAAABQAAAAABABQABADgDACIgBAAQgFABgEACQgJAFADAGQABADANgDQAOgDAEAIQAHALgQAJQgJADgHAAQAAAAgBAAQAAAAAAAAQgBgBAAAAQAAAAAAgBg',
      );
    this.shape_18.setTransform(-44.1837, -83.4095, 2.6223, 2.6226);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#424242')
      .s()
      .p(
        'AgCAaQgGgBgFgHIgOgUQgCgEAEgBQADgDACAEIAOATQAGAKAHgGQAGgEABgMIgOgVQgBgCACgEQADgBACACIAWAfQACAEgDACQgEACgCgDIgCgDQgCAMgHAEQgFADgEAAIgDgBg',
      );
    this.shape_19.setTransform(-55.2951, -77.4575, 2.6223, 2.6226);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#424242')
      .s()
      .p(
        'AgBAfQgCgDACgCIABgBIAHgEQAJgHgJgKIgZgcQgCgEADgCQACgDADADIAZAdQAOAPgOANQgEADgHACIgDgBg',
      );
    this.shape_20.setTransform(-65.5887, -70.6047, 2.6223, 2.6226);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#424242')
      .s()
      .p(
        'AgCAXQgGAAgHgFQgFgGgEgIIABgEQABAAAAAAQABAAABAAQAAAAABAAQAAAAABAAIABABQADAHAEAEQAIAGADgEQACgCgHgMQgHgLAGgHQAIgKAOAMQAFAEADAGQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQgDACgDgCIAAAAQgCgEgFgFQgIgHgEAFQgBADAGALQAHALgGAIQgDADgEAAIgBAAg',
      );
    this.shape_21.setTransform(67.7835, -69.354, 2.6548, 2.6551);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#424242')
      .s()
      .p(
        'AAPAkQgEgCADgDIANgVQAGgKgIgDQgHgFgIAFIgOAWQgCADgEgCQgDgCACgEIAMgTQAGgKgHgFQgGgEgJAEIgOAWQgCADgEgCQgEgCADgCIAVghQABgDAEACQAEACgCAEIgCADQAJgEAHAFQAIAGgCAJQALgEAIAGQAGAEABAGQAAAGgDAFIgPAWQAAABAAAAQAAAAgBABQAAAAgBAAQAAAAAAAAIgDgBg',
      );
    this.shape_22.setTransform(54.1143, -79.4888, 2.6548, 2.6551);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#424242')
      .s()
      .p(
        'AgYAhQgDgBABgEIABgBIAMgMIAAgtQACgEAEACQAAAAABABQAAAAABAAQAAABAAABQAAAAAAABIAAAkIAZgZQAAgBABAAQABAAAAgBQABAAAAAAQABABAAAAQAEABgBAEIguAtIgDACIgCgBg',
      );
    this.shape_23.setTransform(39.8385, -86.3663, 2.6548, 2.6551);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#424242')
      .s()
      .p(
        'AgGAfQgNgDgGgLQgHgLAEgNQADgOAMgGQAKgHAMADQAMADAIAJQABABAAAAQAAABAAAAQAAAAAAABQAAAAAAABQgBADgDgBIgCAAQgIgIgIgCQgJgCgIAEQgIAFgDALQgDAKAFAIQAEAIALADQAJACAHgCIAEgQIgPgEQgCgBAAgDQABgDADABIARAEQAEABgBAEIgFAUQAAADgEABIgLACIgKgCg',
      );
    this.shape_24.setTransform(26.2897, -94.2928, 2.6548, 2.6551);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#424242')
      .s()
      .p(
        'AABAYQgWgBABgXQAAgKAFgGQAGgHAKAAQAKABAGAHQAFAGAAAJQgBAEgEgBIgdgBQABAOANAAQAIAAAEgCIACAAQAEAAgBADQAAABAAAAQAAABAAAAQgBAAAAABQAAAAgBAAQgHAEgHAAIgCAAgAgMgDIAaABQgBgHgEgEQgEgDgEAAIgBAAQgLAAgBANg',
      );
    this.shape_25.setTransform(4.3294, -95.3254, 2.6548, 2.6551);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#424242')
      .s()
      .p(
        'AgLATQgIgGgBgKQgBgKAHgIQAGgHAJgBQAIAAAHADQAAAAAAABQABAAAAAAQAAABAAAAQABABAAAAQABAEgEAAIgCAAQgGgCgFAAQgPACABAPQABAHAFAEQAFAEAGgBQAGAAAEgEIACAAQADgBABAEQAAAAAAABQAAAAAAABQAAAAgBAAQAAABAAAAQgIAFgHABIgDAAQgHAAgGgFg',
      );
    this.shape_26.setTransform(-8.4257, -95.051, 2.6548, 2.6551);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f('#424242')
      .s()
      .p(
        'AACAdIgGglIAAgDQAAAAABgBQAAAAAAAAQABAAAAAAQAAgBABAAQADgBABAEIAHAlQABAFgEAAIgCAAQAAAAgBAAQgBAAAAgBQAAAAgBgBQAAAAAAgBgAgIgZIgBgBQgBgEAFgBIABAAQAAAAABAAQAAAAABAAQAAAAAAAAQABABAAAAQABAAAAAAQAAABAAAAQAAAAAAABQAAAAAAAAIAAABQABAEgEABIAAAAIgCABQgBAAAAgBQgBAAAAAAQgBgBAAAAQAAgBAAgBg',
      );
    this.shape_27.setTransform(-18.2925, -96.0488, 2.6548, 2.6551);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .f('#424242')
      .s()
      .p(
        'AgDASIgIgaIgGABQAAABAAAAQgBAAAAAAQAAAAAAgBQgBAAAAgBIAAgCIAKgQQABAAAAABQABAAAAAAQAAAAABAAQAAABAAAAIABAHIAJgDQAEgBABAEQAAABAAAAQAAABAAAAQAAABgBAAQgBABgBAAIgJACIAGAaQACAGAFgDIAFgCQABAAABAAQAAAAABABQAAAAABAAQAAABAAABQABAAAAABQAAAAgBABQAAAAAAABQAAAAgBAAIgHAEIgFABQgHAAgCgJg',
      );
    this.shape_28.setTransform(-24.7181, -93.1192, 2.6548, 2.6551);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#424242')
      .s()
      .p(
        'AgHAXQgJgEgEgKQgEgJAEgJQAEgIAKgEQAHgDAHACQAAAAABAAQAAAAAAAAQABAAAAABQAAAAABABQABADgDACIgCAAQgFgBgFACQgHADgDAGQgCAFADAGQAGAPAOgGQAEgCAFgEIABgCQAEgBABAEIgBADQgEAGgIADQgFACgFAAQgDAAgEgBg',
      );
    this.shape_29.setTransform(-34.3538, -89.0448, 2.6548, 2.6551);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#424242')
      .s()
      .p(
        'AgFAZQgGgBgDgGQgGgMARgKIAJgFIAAAAQgGgKgJAGQgEABgGAGIgBABQAAAAgBAAQAAAAgBAAQgBAAAAAAQgBgBAAAAQAAgBAAgBQgBAAAAgBQABAAAAgBQAAAAAAgBQAEgFAIgFQAIgEAHACQAGACADAHIANAVQACADgEACQgEACgCgDIgBgCQgDAJgIAFQgEACgDAAIgDAAgAABABQgLAGADAGQADAHAIgFQAHgEACgIIgEgGg',
      );
    this.shape_30.setTransform(-46.4683, -82.8021, 2.6548, 2.6551);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f('#424242')
      .s()
      .p(
        'AAIAYIgVgfQgDgDAEgCIADgBQAAAAABAAQAAAAAAAAQABABAAAAQAAAAAAABIADADQAAgLAFgEIABgBQADgBACACQADADgEADIAAAAQgGAFAAAKIAPAVQACADgDADIgDABQgBAAAAgBQAAAAgBAAQAAAAgBgBQAAAAAAAAg',
      );
    this.shape_31.setTransform(-57.2875, -77.8739, 2.6548, 2.6551);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f('#424242')
      .s()
      .p(
        'AALAiIgkgoQgCgDADgDIAPgOQAJgIAIAAQAIABAFAGQANAPgRAPIgNALIANAOQADADgDADIgDABIgDgBgAgFgTIgLAKIAQARIALgJQAMgLgIgKQgEgEgEAAQgGAAgGAHg',
      );
    this.shape_32.setTransform(-69.1696, -71.1042, 2.6548, 2.6551);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f('#424242')
      .s()
      .p(
        'AgCAYQgGAAgGgGQgHgFgDgIIABgEQADgBACABIABABQADAGAEAEQAIAHADgFQACgCgHgMQgIgKAGgHQAJgLANALQAGAFACAFQABABAAABQAAAAAAABQAAAAAAABQAAAAgBABQgCACgDgCIgBgBQgDgFgDgDQgIgGgEAEQgCADAHALQAIALgGAIQgDAEgFAAIgBAAg',
      );
    this.shape_33.setTransform(61.1042, -69.4815, 2.5094, 2.5094);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f('#424242')
      .s()
      .p(
        'AAEAZQgHAAgIgFQgTgOANgSQAGgIAIgDQAHgDAJAGQAJAGABAJQABAHgGAIQgCADgDgCIgZgQQgGALAMAIQAGAEAFAAIABABQABAAABABQAAAAAAABQAAAAAAABQAAAAgBABQAAABAAAAQAAAAgBABQAAAAAAAAQAAAAgBAAIgBAAgAABgRQgFABgEAFIAVAOQADgFgBgFQgCgFgEgCQgDgDgEAAIgBAAg',
      );
    this.shape_34.setTransform(51.9185, -76.0976, 2.5094, 2.5094);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f('#424242')
      .s()
      .p(
        'AAUAhQgDgCABgDIAKgWQAEgKgIgDQgGgDgJAFIgKAYQgCAEgDgCQgEgCACgDIAIgVQAFgLgIgDQgGgDgJAFIgLAYQgCAEgDgCQgEgBACgEIAPgiQABgFAEACQAEACgBAEIgCADQAIgFAIAEQAJAEAAAKQAJgHAKAFQAHADABAGQACAFgDAHIgKAXQgBABAAABQAAAAgBAAQAAABgBAAQAAAAgBAAIgCgBg',
      );
    this.shape_35.setTransform(36.7668, -84.4902, 2.5094, 2.5094);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f('#424242')
      .s()
      .p(
        'AAKAZQgEgBABgEIABgCQgHAFgKgCQgGgBgDgFQgEgFACgGQADgNATAFIALACIAAAAQACgMgLgCIgLgBIgBAAQgBAAgBgBQAAAAgBAAQAAgBAAgBQAAAAAAgBQAAAAAAgBQABAAAAgBQAAAAABAAQAAgBABAAQAJgBAGACQAJACAEAGQADAGgCAHIgGAYQAAABAAABQgBAAAAABQAAAAgBAAQgBAAAAAAIgCAAgAgMAFQgBAHAJADQAGABAIgFIABgHIgJgCIgGgBQgHAAgBAEg',
      );
    this.shape_36.setTransform(21.0753, -89.415, 2.5094, 2.5094);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f('#424242')
      .s()
      .p(
        'AABAgQgNgBgIgKQgIgJABgOQABgOAKgIQAJgIANABQAMAAAJAIQABAAAAAAQAAABAAAAQABABAAAAQAAABAAAAQAAAEgEgBIgCAAQgHgFgKgCQgKgBgHAGQgHAHgBALQgBAKAGAHQAGAIALAAQAJABAHgDIABgRIgPgBQgEAAABgEQAAgCAEAAIARABQAEAAAAAEIgBAUQgBAEgDACQgIADgIAAIgFAAg',
      );
    this.shape_37.setTransform(7.4543, -93.8737, 2.5094, 2.5094);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f('#424242')
      .s()
      .p(
        'AgNAVQAAAAgBAAQAAAAAAAAQAAgBAAAAQgBgBAAAAQgBgEAEAAIACAAQAHACAEgBQAKgBgBgHQAAgCgNgCQgOgCgBgJQgBgNARgDQAHgBAFACQABAAAAABQABAAAAAAQABABAAAAQAAAAAAABQABAEgEAAIgBAAIgKgBQgKACABAGQAAAEANACQAOABABAJQACANgRACIgEABQgGAAgGgDg',
      );
    this.shape_38.setTransform(-11.6052, -91.3912, 2.5094, 2.5094);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f('#424242')
      .s()
      .p(
        'AgKAXQgFgDgCgIIgHgXQgBgEAEgBIADAAIACACIAGAXQAEALAIgDQAIgCAEgKIgHgZQgBgEAEgBQAEgBABAEIAKAkQABAEgEACQgEABgBgEIgBgEQgFAKgJACIgEABQgFAAgDgDg',
      );
    this.shape_39.setTransform(-23.7234, -89.3314, 2.5094, 2.5094);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f('#424242')
      .s()
      .p(
        'AgKAYIgQgiQgCgEAEgCQAEgBACAEIABADQAFgLAIgDQAGgDAFADQAGADADAHIAKAWQACAEgDACQgEABgCgEIgKgVQgEgKgIADQgHADgDALIAKAYQACAEgEABIgCABQgBAAAAAAQgBAAAAgBQAAAAgBgBQAAAAAAgBg',
      );
    this.shape_40.setTransform(-36.4586, -84.2875, 2.5094, 2.5094);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f('#424242')
      .s()
      .p(
        'AgEAYQgJgDgGgJQgFgKACgHQACgJAJgFQAJgGAHACQAJACAGAKQAFAJgCAIQgCAJgIAFQgGAEgHAAIgEAAgAgHgNQgFADgCAFQgCAFAEAIQAJAOAMgIQAFgDABgFQACgGgEgHQgEgHgHgBIgCAAQgEAAgDACg',
      );
    this.shape_41.setTransform(-48.5663, -78.4741, 2.5094, 2.5094);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f('#424242')
      .s()
      .p(
        'AACAhIgjgpQgDgDAEgCIAQgOQAQgNAJAMQAGAIgEAJQAMgGAHAJQAMAMgSAQIgRAOIgCABIgDgCgAAFgBIgMAKIANAQIAMgLQAMgKgGgHQgDgDgEAAQgFAAgHAFgAgMgVIgMALIAMAOIAMgJQAKgJgHgIQgCgDgDAAQgEAAgGAEg',
      );
    this.shape_42.setTransform(-61.9165, -71.1331, 2.5094, 2.5094);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f('#424242')
      .s()
      .p(
        'AgWAYQgCgDADgDIACgBQgJgCgEgIQgEgHACgIQADgJAKgFQAJgGAJADQAIADAEAHQAEAIgDAIIAUgJQAEgCABADQACAEgEACIgyAbIgCABQgBAAAAAAQgBgBAAAAQgBAAAAgBQAAAAAAgBgAgSgPQgOAHAHAMQAFAIAIACIAQgJQADgIgEgHQgEgIgHAAQgFAAgFADg',
      );
    this.shape_43.setTransform(80.6635, -45.9058, 2.391, 2.391);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f('#424242')
      .s()
      .p(
        'AgaATQgDgDAEgDIAvggQADgCADADQACAEgDACIgwAgIgCABQAAAAgBAAQAAAAgBgBQAAAAgBAAQAAgBAAAAg',
      );
    this.shape_44.setTransform(75.0511, -55.7665, 2.391, 2.391);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f('#424242')
      .s()
      .p(
        'AgXAPQgDgDADgDIAdgXQAEgDACADQADADgDADIgEACQAMAAAEAGIAAAAQADACgDADQgEADgCgEIAAAAQgGgGgJABIgVAQIgCABIgDgBg',
      );
    this.shape_45.setTransform(69.6406, -60.9293, 2.391, 2.391);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f('#424242')
      .s()
      .p(
        'AgPARQgIgHAAgJQAAgIAIgIQAHgIAJAAQAIAAAIAHQAHAHAAAJQAAAJgIAHQgHAIgJAAQgIAAgHgHgAgKgJQgGAGABAFQAAAGAEAEQAFAEAFAAQAGABAGgGQAGgGgBgGQAAgFgEgEQgGgFgFAAQgEAAgHAGg',
      );
    this.shape_46.setTransform(62.0493, -67.5679, 2.391, 2.391);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f('#424242')
      .s()
      .p(
        'AgIArQgDgCABgEIAMguIgkAeQgDACgEgCQgDgDABgDIAPg4QADgDADACQADACgBADIgPAxIAnggQACgCAEACQADACgBADIgOAxIAnghQACgBADAAQAEADgDADIgBABIgrAjQgBABAAAAQgBAAAAAAQgBABAAAAQAAAAgBAAIgDgBg',
      );
    this.shape_47.setTransform(51.6835, -81.3607, 2.391, 2.391);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f('#424242')
      .s()
      .p(
        'AgGAbQgMgFAEgLIAKgZIgGgCQgBgBAAAAQgBAAAAAAQAAgBAAAAQAAAAABAAIABgCIAOgHIACAAQABAAAAABQAAAAAAAAQABABgBAAQAAAAAAABIgCAGIAJAEQABAAAAABQABAAAAABQAAAAAAABQAAAAAAABQAAABgBABQAAAAAAABQgBAAgBAAQAAAAgBgBIgKgDIgIAYQgCAGAFABIAFACQAAAAABAAQAAABABAAQAAABAAAAQgBABAAABQAAAAAAABQgBAAAAAAQAAAAgBABQAAAAgBAAIAAAAIgGgBg',
      );
    this.shape_48.setTransform(31.8933, -88.0517, 2.391, 2.391);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f('#424242')
      .s()
      .p(
        'AAMAbQgEgBABgEIAGgXQACgLgJgCQgIgCgIAHIgGAZQgBAEgEgBQgEgBABgEIAJgkQABgFAEABQAEACgBAEIgBADQAIgGAKACQAHACADAGQADAGgCAHIgGAYQgBABAAAAQAAABgBAAQAAABgBAAQAAAAgBAAIgBAAg',
      );
    this.shape_49.setTransform(20.6378, -90.575, 2.391, 2.391);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f('#424242')
      .s()
      .p(
        'AAAAYQgXgDADgWQABgKAFgGQAHgHAJABQAKABAGAHQAFAHgBAJQgBAEgEgBIgdgDQAAAOANABQAFABAHgCIACgBQADABAAADQAAABAAAAQAAABgBAAQAAAAAAABQgBAAAAAAQgGADgIAAIgCAAgAgMgEIAaACQAAgGgEgEQgDgEgFAAIgCAAQgKAAgCAMg',
      );
    this.shape_50.setTransform(8.7215, -92.6169, 2.391, 2.391);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f('#424242')
      .s()
      .p(
        'AggAWIgDgmQgBgDAFgBQAEAAAAAEIAAADQAGgIAJgBQAKgBAEAJQAEgKALAAQAIgBAEAFQAEAFABAHIACAZQAAADgEABQgEAAgBgEIgBgXQgBgLgJAAQgIABgFAJIACAaQABAEgEAAQgEAAAAgDIgCgYQAAgLgKABQgHAAgFAJIACAaQAAAEgEABQgDAAgBgEg',
      );
    this.shape_51.setTransform(-7.131, -92.7942, 2.391, 2.391);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f('#424242')
      .s()
      .p(
        'AgKAVQgIgEgDgLQgCgJADgIQAEgIAKgDQAJgCAHAFQAHAFADAJQABAEgEABIgdAGQAFANANgEQAIgCADgDIABgBQAEgBABADQAAABAAAAQAAABAAAAQgBABAAAAQAAABgBAAQgGAGgIACIgHABQgGAAgEgDgAgEgPQgMADADAMIAYgGQgCgGgFgCQgDgCgBAAIgEABg',
      );
    this.shape_52.setTransform(-22.6435, -90.2942, 2.391, 2.391);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f('#424242')
      .s()
      .p(
        'AACAXIgNgjQgCgDAEgCQAEgBABADIACAEQACgKAHgDIAAAAQAEgCABAEQACAEgEABQgIAEgCAJIAJAYQABAEgDACIgCAAQAAAAgBAAQAAAAgBgBQAAAAgBgBQAAAAAAgBg',
      );
    this.shape_53.setTransform(-33.4406, -87.5757, 2.391, 2.391);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f('#424242')
      .s()
      .p(
        'AgFAaQgGgCgDgHIgMgVQgCgEAEgCQAEgCABAEIAMAVQAFAKAIgFQAGgEADgLIgNgXQgCgDAEgCQADgCACAEIASAhQACAEgDABQgEACgCgDIgCgEQgDALgIAEQgEACgDAAIgFgBg',
      );
    this.shape_54.setTransform(-42.01, -83.3595, 2.391, 2.391);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f('#424242')
      .s()
      .p(
        'AgEAYQgCgDADgCIABAAQAHgCAEgDQAIgGgEgFQgBgDgMAFQgNAFgGgIQgEgEACgFQABgGAHgFQAEgDAIgDQABgBAAAAQAAAAABABQAAAAABAAQAAABAAAAQADAEgEABIgJAFQgIAGADAGQACACANgEQANgFAFAIQAEADgCAGQgBAGgHAFQgJAFgGABQAAAAgBAAQAAgBgBAAQAAAAAAAAQgBAAAAgBg',
      );
    this.shape_55.setTransform(-51.6958, -76.9231, 2.391, 2.391);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f('#424242')
      .s()
      .p(
        'AgJAUQgKgLAQgNIAHgHIgBgBQgHgIgIAIIgIAKIAAABQgDABgCgBQAAgBgBAAQAAgBAAAAQAAgBAAgBQAAAAAAgBQAEgIAGgEQAGgHAIABQAGABAFAFIARASQACADgDADQgDADgCgEIgCgBQgBAJgHAHQgFAFgFAAQgEAAgFgFgAABAAQgJAJAFAFQAEAFAGgGQAGgFAAgJIgFgFg',
      );
    this.shape_56.setTransform(-60.1006, -69.5228, 2.391, 2.391);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f('#424242')
      .s()
      .p(
        'AgPAQQgHgGgCgIQgCgJAHgHQAHgIAJAAQAHAAAHAGQADADgCADIgTAWQAKAHAJgLQAFgFABgFIABgBQACgDADACQAAABABAAQAAABAAAAQAAABAAAAQAAABAAAAQgCAIgFAGQgIAJgJAAQgHAAgJgHgAgOgKQgDAEAAAFQAAAEAFAFIAQgUQgEgDgEAAQgFAAgFAFg',
      );
    this.shape_57.setTransform(-68.092, -61.4768, 2.391, 2.391);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f('#424242')
      .s()
      .p(
        'AAGArIgugaQAAAAAAgBQgBAAAAAAQAAgBgBAAQAAgBAAgBQAAAAAAgBQAAAAAAgBQAAgBAAAAQAAgBAAAAIACgDQABgEAFABIA1AIIghgqQgCgEABgDIACgCQADgFAFACIAuAbQADACgCAEQgCADgEgCIgrgZIAhAqQADAEgCADQgCAEgEgBIg2gHIArAZQAEADgDADQAAABAAAAQgBAAAAABQAAAAgBAAQAAAAgBAAIgCgBg',
      );
    this.shape_58.setTransform(-79.3688, -49.258, 2.391, 2.391);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f('#424242')
      .s()
      .p(
        'AgKAgQgDgDACgEIANgaIgbANQgDABgDgCQgDgEACgDIASgiIABgBQADgDACADQABAAABABQAAAAAAABQAAAAAAABQAAABgBAAIgRAfIAegPQADgCADADQACACgCADIgQAeIAggQQAAgBABAAQABAAAAAAQABAAAAABQABAAAAAAQADAEgDACIgBABIgjARIgDABQAAAAgBgBQAAAAgBAAQAAAAAAAAQgBgBAAAAg',
      );
    this.shape_59.setTransform(67.4029, -65.971, 2.5068, 2.5068);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f('#424242')
      .s()
      .p(
        'AgNATQgJgGgBgJQgBgIAHgJQAGgIAJgCQAIgBAIAGQAIAGACAJQABAIgGAJQgHAIgJACIgDAAQgHAAgGgFgAAAgPQgGABgFAGQgFAHABAFQABAGAFADQAFAEAFgBQAGgBAFgGQAFgHgBgFQgCgGgFgDQgDgEgFAAIgBABg',
      );
    this.shape_60.setTransform(54.4834, -74.9416, 2.5068, 2.5068);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f('#424242')
      .s()
      .p(
        'AAGAlQgEgBACgEIAMgWQAFgKgJgDQgHgEgJAEIgNAXQgBADgEgBQgEgCACgEIAagzQADgDADACQADACgBAEIgKAUQAKgEAHAEQAHAEABAGQACAGgEAHIgMAWQAAABAAAAQgBABAAAAQAAAAgBABQAAAAgBAAIgCgBg',
      );
    this.shape_61.setTransform(42.5118, -84.3398, 2.5068, 2.5068);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f('#424242')
      .s()
      .p(
        'AgJAeQgKgDgIgIQAAAAgBgBQAAAAAAgBQgBAAAAgBQAAgBABAAQABgEADABIACABQAHAHAIADQAOAFADgKQACgFgPgLQgQgKAEgMQADgHAHgDQAHgDALAEQAGACAJAGQABABAAAAQAAABAAAAQABABAAABQAAAAgBABQgCADgCgBIgBgBQgHgFgHgCQgNgGgEAKQgCAGAPAMQARAKgFAMQgDAHgHACIgHABQgEAAgGgCg',
      );
    this.shape_62.setTransform(31.2952, -89.5721, 2.5068, 2.5068);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f('#424242')
      .s()
      .p(
        'AANAhQgBAAAAAAQgBAAAAAAQAAgBAAAAQgBAAAAgBQAAAAgBAAQAAgBAAAAQAAAAAAgBQAAAAAAgBIABgCQgHAFgJAAQgIgBgFgHQgGgIABgLQACgKAHgGQAHgFAIABQAJACAFAHIADgWQABgDAEAAQAEABgBAEIgIA4QAAABAAABQAAABgBAAQAAABgBAAQAAAAgBAAIgBAAgAgKgFQgFAEgBAGQgCARAPABQAGACAIgHIACgSQgFgHgIgBIgCAAQgEAAgEADg',
      );
    this.shape_63.setTransform(12.2284, -94.0937, 2.5068, 2.5068);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f('#424242')
      .s()
      .p(
        'AgTAUIgBgmQAAgEAEAAQAEAAAAAEIAAAEQAIgJAIAAQAHAAAFAFQAEAFAAAIIABAYQAAAEgEAAQgEABAAgFIgBgXQAAgMgKABQgGAAgIAJIABAaQAAADgEABQgEAAAAgEg',
      );
    this.shape_64.setTransform(-1.7324, -93.1138, 2.5068, 2.5068);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f('#424242')
      .s()
      .p(
        'AgNAWQgFgDgBgGQgCgOAVgDIAJgBIAAgBQgCgLgKACQgGABgGADIgBAAQgBAAgBAAQAAAAgBgBQAAAAgBAAQAAgBAAgBQAAAAAAgBQAAAAAAgBQABAAAAgBQAAAAABgBQAJgEAGgBQARgCADARIAEAYQABAEgFAAQgDABgBgEIgBgCQgEAHgKACIgDAAQgFAAgDgCgAABACQgNABABAIQABAHAKgCQAGAAAFgIIgBgIg',
      );
    this.shape_65.setTransform(-14.6323, -91.9181, 2.5068, 2.5068);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f('#424242')
      .s()
      .p(
        'AgEAcIgagdIgBgCQgBgEAEgBQAAAAABAAQABAAAAAAQABAAAAAAQAAABABAAIAWAcIgCgjQAAgDADgBQABgCADADIAWAbIgDgjQAAgBAAAAQAAgBABAAQAAgBABAAQAAgBABAAQAEgBABAEIABABIABAnQAAAEgDABQgFABgCgDIgTgXIABAeQAAAEgDACIgCAAQAAAAgBAAQAAAAgBAAQAAgBgBAAQAAAAAAgBg',
      );
    this.shape_66.setTransform(-35.9159, -87.5247, 2.5068, 2.5068);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f('#424242')
      .s()
      .p(
        'AgFAYQgJgDgFgKQgFgIACgJQACgIAJgFQAJgGAIADQAIACAGAJQAFAJgCAJQgCAJgJAEQgGAEgGAAIgFAAgAgHgNQgFADgCAFQgCAFAEAIQAEAHAHABQAEABAFgDQAFgDACgFQACgGgEgHQgEgHgHgCIgCAAQgDAAgEADg',
      );
    this.shape_67.setTransform(-48.3595, -80.0782, 2.5068, 2.5068);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f('#424242')
      .s()
      .p(
        'AgDAaIgYgdQgCgEADgCQACgDAEADIACADQAAgLAIgGQAFgEAGABQAGABAFAGIAQATQACADgDADQgCACgEgDIgPgSQgGgJgHAHQgGAFgBAKIAQAVQADACgDADIgCABIgDgBg',
      );
    this.shape_68.setTransform(-59.4523, -71.8356, 2.5068, 2.5068);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f('#424242')
      .s()
      .p(
        'AAEAkIgoglQgDgDADgDQACgCAEACIAVASIgDgqIABgEQADgCADACIABADIABAdIAlADIADAAIABACIgBADQAAABAAAAQgBAAAAAAQgBAAAAAAQgBAAAAAAIglgCIABAOIAMAMQADADgDACIgDACIgDgBg',
      );
    this.shape_69.setTransform(-70.9693, -64.3621, 2.5068, 2.5068);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f('#424242')
      .s()
      .p(
        'AgCAdQgDgBACgEIABgCQgIADgJgFQgIgEgCgIQgDgIAFgKQAFgJAJgDQAJgDAHAEQAHAEADAKIAKgUQACgDAEACQAEACgCADIgcAzQgBAAAAABQAAAAgBAAQAAABAAAAQgBAAAAAAIgCgBgAgUgGQgDAGABAGQACAFAGADQAGAEAIgDIAJgQQgBgIgIgEQgEgDgDAAQgIAAgFAKg',
      );
    this.shape_70.setTransform(47.9594, -82.5629, 2.655, 2.655);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f('#424242')
      .s()
      .p(
        'AgLAfQgEgBABgEIAVg1QABgEAEABQAEACgBADIgWA1QAAABAAABQAAAAgBABQAAAAgBAAQAAAAgBAAIgBAAg',
      );
    this.shape_71.setTransform(37.7897, -89.2668, 2.655, 2.655);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f('#424242')
      .s()
      .p(
        'AgPAWQgEgBABgEIAMgkQABgEAEACQAEABgCAEIgBADQAJgGAHADIAAAAQAEABgBAEQgCAEgDgCIgBAAQgIgCgHAGIgIAZQAAABAAAAQgBABAAAAQgBAAAAABQgBAAgBAAIgBgBg',
      );
    this.shape_72.setTransform(30.5548, -89.9163, 2.655, 2.655);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f('#424242')
      .s()
      .p(
        'AgEAYQgKgCgFgIQgFgIACgJQADgLAHgFQAHgGAKADQAKACAFAIQAFAHgCAKQgCAKgIAFQgFAEgHAAIgFAAgAgGgNQgGADgCAIQgBAIAEAEQADAFAGABQANADAEgQQACgPgOgDIgDAAQgDAAgDACg',
      );
    this.shape_73.setTransform(18.4746, -92.32, 2.655, 2.655);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f('#424242')
      .s()
      .p(
        'AANAcIgNgtIgPAsQgBAEgEAAQgEAAgBgEIgRg2QAAgFAEAAQADAAABAEIAOAxIAQgwQABgDADgBQADAAACAEIAOAwIAQgwQAAgBABAAQAAgBAAAAQABgBABAAQAAAAABAAQAFAAgBAEIAAABIgTA1QgCAEgDABQgEAAgCgFg',
      );
    this.shape_74.setTransform(-0.2874, -96.4353, 2.655, 2.655);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f('#424242')
      .s()
      .p(
        'AgOAeQgDgKAPgPQANgPgCgHQgCgLgNAEQgHABgHAGIgCABQAAAAgBAAQgBAAAAAAQgBgBAAAAQAAgBgBgBQAAAAAAgBQAAAAAAgBQAAAAAAgBQABAAAAAAQAHgHALgDQAIgCAHADQAHAEACAIQADAKgNAOQgOARAAADIAdgIQAEgBABAEQABAEgEABIghAIIgCABQgBAAAAAAQgBgBAAAAQAAgBgBAAQAAgBAAgBg',
      );
    this.shape_75.setTransform(-26.0114, -92.7807, 2.655, 2.655);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f('#424242')
      .s()
      .p(
        'AgKAEQgBgBAAAAQAAgBAAgBQABAAAAgBQABAAABAAIAOgGQAEgBABADQABADgDABIgPAGIgCABQAAAAAAAAQgBAAAAgBQAAAAgBgBQAAAAAAgBg',
      );
    this.shape_76.setTransform(-37.3357, -87.7512, 2.655, 2.655);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f('#424242')
      .s()
      .p(
        'AgHAjIgbgwQgCgDAEgCQADgCACAEIAOAYIAMgqIABgCIADgBIACACIAAADIgHAcIAjAOIACACQACADgEACIgEAAIghgPIgEAOIAIAPQABAEgDACIgCABQgBAAAAAAQgBgBAAAAQAAAAgBgBQAAAAAAgBg',
      );
    this.shape_77.setTransform(-48.8607, -83.9487, 2.655, 2.655);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f('#424242')
      .s()
      .p(
        'AgcAUQgDgEAFgDQAFgDACAFQADAEgFADIgDABQgCAAgCgDgAAFAPQgJgEgEADQgDABgCgDQgCgDADgCQAHgEAJADQALAEADgBQAIgFgGgKQgDgGgFgDIgCgCIAAgCIABgCQABgBAAAAQABAAAAAAQABAAAAAAQABAAABABQAHAEAEAIQAEAIgBAGQgBAHgHAEQgDABgEAAQgEAAgGgCg',
      );
    this.shape_78.setTransform(84.3206, -49.1914, 2.5041, 2.5041);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f('#424242')
      .s()
      .p(
        'AgNAgQgCgDACgEIARgZIgcAKQgEABgDgDQgDgDADgDIAXgiQAEgCACADQAAABABAAQAAABAAAAQAAABAAAAQgBABAAABIgVAcIAggLQADgCACADQADADgCADIgUAcIAhgNQAAgBABAAQABAAAAAAQABABAAAAQABAAAAABIABADQAAABAAAAQAAAAgBABQAAAAAAAAQAAAAgBABIgBABIgkAMIgDABQgBAAAAAAQgBgBAAAAQAAAAgBAAQAAgBgBAAg',
      );
    this.shape_79.setTransform(75.6719, -59.5793, 2.5041, 2.5041);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f('#424242')
      .s()
      .p(
        'AgQASQgHgIAAgJQAAgIAHgIQAHgHAJgBQAIgBAIAHQAIAIAAAJQAAAIgHAIQgHAIgJAAIgBAAQgIAAgIgGgAgKgJQgFAGAAAFQAAAGAFAEQAKAKALgMQAKgKgKgLQgFgEgFAAQgFAAgGAGg',
      );
    this.shape_80.setTransform(64.2155, -69.7119, 2.5041, 2.5041);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f('#424242')
      .s()
      .p(
        'AACAdQgCgDABgDIAOgUQAHgIgJgGQgFgEgLADIgPAVQgCADgEgCQgDgCACgEIAWgeQADgEACACQADADgCADIgCADQAKgDAIAGQAGAEABAHQABAGgEAGIgPAVQAAAAAAABQgBAAAAAAQAAAAgBAAQAAABgBAAIgDgBg',
      );
    this.shape_81.setTransform(53.2451, -78.0291, 2.5041, 2.5041);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f('#424242')
      .s()
      .p(
        'AAFAlQAAAAAAAAQgBAAAAgBQAAAAAAgBQgBAAAAgBIgHgjIgOADIgHAQQgBADgEgCQgEgBACgEIAYgxQACgEAEACQACACgBAEIgMAZIAogOIAEAAQAEACgDADIgCACIgbAJIAIAlQAAAAAAABQAAAAAAAAQAAABAAAAQAAABAAAAQAAABgBAAQAAAAAAABQgBAAAAAAQgBAAAAAAIgDgBg',
      );
    this.shape_82.setTransform(42.9616, -86.7325, 2.5041, 2.5041);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f('#424242')
      .s()
      .p(
        'AAJAbQgFgBACgEIABgEQgIAGgJgCQgIgCgDgGQgDgGACgHIAHgYQABgEAEABQADABgBAEIgGAXQgCAKAJADQAHACAJgHIAGgZQABgEAEABQAEABgBAEIgJAlQAAABgBAAQAAABAAAAQgBABAAAAQgBAAAAAAIgCAAg',
      );
    this.shape_83.setTransform(23.5734, -91.8109, 2.5041, 2.5041);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f('#424242')
      .s()
      .p(
        'AgBAYQgLgBgFgHQgGgHABgKQABgLAHgGQAHgFAJAAQALABAFAIQAGAHgBAKQgBAKgHAGQgGAFgIAAIgCAAgAgIgMQgFAEgBAIQgBAPAOACQAOABACgQQACgPgPgCIgCAAQgEAAgEADg',
      );
    this.shape_84.setTransform(10.0636, -94.1758, 2.5041, 2.5041);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f('#424242')
      .s()
      .p(
        'AgCAcIAAgXIgXgdIAAgCQAAAAAAgBQAAAAAAAAQAAgBAAAAQAAAAABAAQAAgBAAAAQABAAAAgBQAAAAABAAQAAAAAAAAQABAAAAAAQABAAABAAQAAABAAAAQABAAAAABIATAbIASgcQAAgBABAAQAAAAAAAAQABgBAAAAQABAAAAAAQAEAAAAAEIAAACIgVAeIAAAXQAAAEgEAAQgDAAAAgEg',
      );
    this.shape_85.setTransform(-1.8467, -96.7566, 2.5041, 2.5041);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f('#424242')
      .s()
      .p(
        'AgLAVQgIgFgCgLQgDgJAFgIQAFgIAKgCQAIgCAJAFQAHAFADAKQACAJgFAIQgEAIgKACIgGABQgGAAgFgDgAgDgPQgFACgDAEQgEAFACAHQABAJAGADQAFADAFgCQAFgBAEgFQADgFgBgHQgEgNgLAAIgDAAg',
      );
    this.shape_86.setTransform(-20.6747, -92.1538, 2.5041, 2.5041);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f('#424242')
      .s()
      .p(
        'AgJAfIgVgxQgCgEAEgBIARgHQANgGAMAGQAKAFAFAMQAFALgEAKQgEANgOAGIgQAHIgCAAQAAAAgBAAQAAAAgBgBQAAAAgBAAQAAgBAAgBgAgJgXIgMAFIASArIALgFQAKgEAEgJQADgHgEgKQgEgKgIgEQgEgBgEAAQgEAAgGACg',
      );
    this.shape_87.setTransform(-36.3116, -88.7155, 2.5041, 2.5041);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f('#424242')
      .s()
      .p(
        'AAAASIgPgXIgFAEQAAAAgBAAQAAAAAAAAQgBAAAAAAQAAgBAAAAIAAgBIADgRIABgCQABAAAAAAQAAAAAAAAQABAAAAAAQAAAAAAABIAEAGIAJgGQADgBABACQACADgDACIgIAGIAOAVQADAEAFgCIAEgEQABAAABgBQAAAAABAAQABAAAAABQABAAAAABQAAABAAAAQAAABAAAAQAAAAAAABQAAAAAAABIgGAFQgEADgEAAQgFAAgEgFg',
      );
    this.shape_88.setTransform(-50.4426, -80.1274, 2.5041, 2.5041);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f('#424242')
      .s()
      .p(
        'AgKAUQgJgLAQgNIAHgHIAAAAQgGgJgKAIQgFAFgCAEIgBABQgBABgBAAQAAAAgBAAQgBAAAAAAQAAgBgBAAQAAgBAAAAQgBgBAAgBQAAAAAAgBQAAAAABgBQADgGAHgGQAHgGAHABQAGABAEAGIARASQACADgDADQgDADgDgDIgBgCQgBAJgIAHQgEAEgFAAQgGgBgEgEgAABAAQgJAIAEAGQAEAFAHgGQAGgFAAgIIgEgGg',
      );
    this.shape_89.setTransform(-58.5202, -72.7974, 2.5041, 2.5041);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f('#424242')
      .s()
      .p(
        'AAIAaIgqgnQgEgDADgDQADgDADADIARAQQgBgLAHgHQAFgFAGAAQAGAAAGAFIASASQAEACgDACQgDADgDgCIgSgQQgIgIgGAIQgGAGACAJIATATQADADgDACQAAABAAAAQgBAAAAAAQAAABgBAAQAAAAgBAAIgCgBg',
      );
    this.shape_90.setTransform(-69.8184, -63.8469, 2.5041, 2.5041);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f('#424242')
      .s()
      .p(
        'AAQAsIg3gNIgBgBQgEgCADgDQAAgBABgBQAAAAABAAQAAgBABAAQABAAAAABIAyANIghgmQgDgDACgDQACgDADABIAyAMIgigmQgCgCACgDQAAgDAEACIABABIAlAqQACAEgBADQgDAEgDgBIgugLIAeAjQADAEgCADQgCACgDAAIgBAAg',
      );
    this.shape_91.setTransform(-81.9507, -53.3294, 2.5041, 2.5041);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f('#424242')
      .s()
      .p(
        'AgUALQgEgIAAgIIACgCQADgCACADIAAACQAAAFADAGQAFAJAFgDQADgBgDgNQgDgOAIgEQAMgHAIAQQAEAIAAAEQAAAAAAABQAAABAAAAQgBABAAAAQAAAAgBABQgDACgCgEIAAgBQgBgEgCgFQgFgJgFADQgEACADAMQADAOgIAEQgDACgDAAQgIAAgFgLg',
      );
    this.shape_92.setTransform(86.1579, -41.4534, 2.567, 2.567);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f('#424242')
      .s()
      .p(
        'AgOAXIgFgGQgIgKAKgHIAXgOIgEgGQAAAAAAAAQAAgBAAAAQAAAAAAgBQABAAAAAAIACAAIAQAEIACAAQAAABAAAAQAAABAAAAQAAAAAAABQAAAAgBAAIgGAEIAGAIQACADgDABQgDACgCgDIgGgHIgWANQgEADADAFIAEAEQAAABABABQAAAAAAABQAAAAgBABQAAAAgBABIgCAAIgCAAg',
      );
    this.shape_93.setTransform(82.1387, -49.86, 2.567, 2.567);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f('#424242')
      .s()
      .p(
        'AgFAYQgHgCgGgHQgGgIABgIQAAgKAJgGQAIgHAJABQAJABAGAIQAFAGABAIQAAAAAAAAQAAABAAAAQAAAAgBABQAAAAAAABQgCACgDgDIgBgCIgEgIQgKgOgMALQgGAEAAAHQgBAFAFAGQACADAGADIACABQABADgCACIgBABIgCAAg',
      );
    this.shape_94.setTransform(75.8849, -57.64, 2.567, 2.567);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f('#424242')
      .s()
      .p(
        'AgDAaQgCgDACgDIACgCQgKABgHgHQgFgFAAgFQgBgFAEgEQALgLAOAPIAHAGIABAAQAIgIgJgIIgKgHIgBAAIgBgCIABgDQAAAAAAgBQABAAAAAAQABAAAAAAQABAAABAAQAHADAGAGQAHAGAAAIQAAAFgFAFIgSATIgCABIgDgBgAgNgCQgFAEAHAHQAGAFAIgBIAFgFIgHgHQgGgFgEAAQgBAAAAAAQgBAAAAAAQgBABAAAAQgBAAAAABg',
      );
    this.shape_95.setTransform(66.3206, -67.2944, 2.567, 2.567);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f('#424242')
      .s()
      .p(
        'AggAZQgDgDACgCIAhgsIACgBIADABIAcAVQADABgCADQgDADgDgCIgYgSIgLAQIAVAQQACACgBADQgDADgDgCIgVgRIgOATQAAABgBAAQAAABgBAAQAAAAAAAAQgBAAAAAAIgDgBg',
      );
    this.shape_96.setTransform(59.9312, -78.8299, 2.567, 2.567);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f('#424242')
      .s()
      .p(
        'AgJAZQgLgGAFgKIANgYIgGgDQgBAAAAAAQAAgBAAAAQAAAAAAgBQAAAAAAAAIACgBIAPgGIACAAQAAABAAAAQAAAAAAABQAAAAAAAAQAAABAAAAIgDAGIAJAFQABAAAAABQABABAAAAQAAABAAAAQAAABAAAAQgCADgDgBIgJgEIgLAXQgDAFAFACIAFACQAAAAABABQAAAAAAABQAAAAAAABQAAABAAAAQAAABgBAAQAAABAAAAQAAAAgBAAQAAAAAAAAg',
      );
    this.shape_97.setTransform(44.8912, -84.1618, 2.567, 2.567);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f('#424242')
      .s()
      .p(
        'AAJAcQgDgCABgEIAIgWQAEgKgJgDQgIgDgIAGIgJAYQgCAEgEgCQgEgBACgEIANgjQACgEAEABQADACgBAEIgBADQAJgFAIADQAHADADAGQACAGgDAGIgIAYQgBABAAAAQAAABgBAAQAAABgBAAQgBAAAAAAIgCAAg',
      );
    this.shape_98.setTransform(33.1776, -88.2048, 2.567, 2.567);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f('#424242')
      .s()
      .p(
        'AAIAUIAAgCQgIAFgJgCQgNgDACgNQADgOATAFIALACIAAgBQADgKgNgDQgDgBgIABIgBgBQgBAAAAAAQgBAAAAgBQgBAAAAgBQAAgBABgBQAAAAAAgBQAAAAAAgBQABAAAAAAQABAAABAAQAIgCAHACQAJACADAGQAEAGgCAHIgFAYQgBADgEAAQgEgBABgEgAgMAGQgCAHAKACQAHABAHgFIABgHIgJgDIgFAAQgIAAgBAFg',
      );
    this.shape_99.setTransform(20.3386, -91.6703, 2.567, 2.567);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f('#424242')
      .s()
      .p(
        'AgJAPIADgbIgGAAQgBAAAAgBQAAAAgBAAQAAAAAAgBQAAAAAAAAIABgCIANgKQAAAAAAgBQAAAAAAAAQAAAAAAAAQABAAAAAAIABACIgBAHIALABQABAAAAAAQABABAAAAQABABAAAAQAAABAAABQAAADgEAAIgKgBIgCAaQgBAFAGABIAFAAQABAAAAAAQABAAAAABQABAAAAABQAAAAAAABQAAABgBAAQAAABAAAAQAAABgBAAQAAAAgBAAIgHABQgMgBABgMg',
      );
    this.shape_100.setTransform(10.8802, -94.494, 2.567, 2.567);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f('#424242')
      .s()
      .p(
        'AgMAUIAAgnQAAgDAEAAQAEgBAAAFIAAAEQAGgJAIABIAAAAQAEAAAAADQAAAFgEAAIgBAAQgJgBgEAIIAAAbQAAADgFABQgEgBABgDg',
      );
    this.shape_101.setTransform(2.6424, -94.0448, 2.567, 2.567);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f('#424242')
      .s()
      .p(
        'AgOATQgHgGgBgLQgBgJAFgHQAGgIAKgBQAKgBAHAGQAHAGABALQABAJgGAHQgFAIgKABIgDAAQgIAAgGgFgAgBgPQgFAAgEAEQgFAFABAHQABAIAFAEQAFAEAFgBQAPgCgCgPQgBgIgGgEQgDgCgEAAIgCAAg',
      );
    this.shape_102.setTransform(-9.3993, -93.4672, 2.567, 2.567);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f('#424242')
      .s()
      .p(
        'AgJAhIgPg5QgBgEAEgBQAEgBABAEIABACQAEgIAJgCQAIgCAHAEQAIAFADALQADAKgFAHQgFAIgIACQgIACgIgFIAGAXQABAEgEABIgBAAQgBAAgBAAQAAAAgBgBQAAAAAAgBQgBAAAAgBgAgBgaQgIACgEAIIAEARQAIAFAHgCQAOgEgEgOQgDgNgKAAIgEABg',
      );
    this.shape_103.setTransform(-23.4366, -88.0656, 2.567, 2.567);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f('#424242')
      .s()
      .p(
        'AgWAeIgQgiQgCgDADgCQAEgCACAEIACADQACgKAIgEQAIgEAJAHQABgLAIgFQAHgDAGADQAGADACAGIAMAXQACADgFACQgDACgCgEIgKgVQgFgKgJAEQgGADgCAKIAMAYQACADgEACQgDACgCgEIgKgVQgFgKgIAEQgHADgBAJIALAZQADADgFACIgCABQAAAAgBAAQAAAAgBgBQAAAAAAAAQgBgBAAgBg',
      );
    this.shape_104.setTransform(-39.9468, -84.5255, 2.567, 2.567);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f('#424242')
      .s()
      .p(
        'AAMAaIgeguQgCgDADgDQAEgCADAEIAcAtQADADgDADIgDABQAAAAgBgBQAAAAgBAAQAAAAAAgBQgBAAAAAAg',
      );
    this.shape_105.setTransform(-52.9102, -80.2378, 2.567, 2.567);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f('#424242')
      .s()
      .p(
        'AAVAhIgBgBIgFgQIgngSIgCgBQgCgDACgDQABAAAAAAQABAAAAAAQABgBAAABQABAAABAAIAgAPIgLgiQgBAAAAgBQAAgBAAAAQABgBAAAAQAAgBAAAAQADgDADADIAWA9QAAABAAAAQAAABAAAAQAAABAAAAQgBABAAAAIgDACIgDgCg',
      );
    this.shape_106.setTransform(-64.0018, -68.3571, 2.567, 2.567);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f('#424242')
      .s()
      .p(
        'AAMAXIgcgZQgDgCACgEQADgCADACIADADQgCgLAGgGQACgDACADQADACgDAEIAAAAQgFAGADAKIATARQADACgDAEIgCABIgDgBg',
      );
    this.shape_107.setTransform(-71.7778, -62.7126, 2.567, 2.567);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f('#424242')
      .s()
      .p(
        'AgNARQgIgGgCgHQgDgIAGgJQAGgIAJgBQAIgBAHAGQAEACgDADIgQAYQAKAHAIgMQAEgFABgFIABgCQACgDACACQABAAAAABQAAAAABABQAAAAAAABQAAAAAAABQgBAHgFAHQgIALgKAAQgGAAgIgGgAgGgOQgFABgDAEQgDAEABAFQAAAFAFAEIAOgVQgDgDgDAAIgDABg',
      );
    this.shape_108.setTransform(-77.0401, -53.6418, 2.567, 2.567);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f('#424242')
      .s()
      .p(
        'AgeAYIgCAAQgDgDACgDQAAgBAAAAQABAAAAgBQABAAAAAAQABAAABAAIA3AGIgkgrQAAAAAAgBQgBAAAAgBQAAgBAAAAQAAgBABAAQABgFAEADIABABIAlAsQADADgCADIgBACQgBADgFAAg',
      );
    this.shape_109.setTransform(-87.6502, -46.0673, 2.567, 2.567);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f('#58595B')
      .s()
      .p(
        'AghAMQgDgLABgIQAAAAABgBQAAAAAAAAQAAgBABAAQAAAAABAAQADgBABADIAAACQgBAHADAHQAEANAOgFIAGgCQgJgDgCgJQgDgHADgIQAEgJAKgDQAKgEAJAFQAHAEADAIQADAIgFAIIACgBQAEgBACAEQABAEgEABIglANQgGACgFAAQgNAAgFgPgAADgQQgGACgDAGQgCAFACAFQACAHAIAEIARgGQAFgHgDgHQgDgKgJAAIgIABg',
      );
    this.shape_110.setTransform(86.0157, -29.5197, 2.491, 2.4932);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f('#58595B')
      .s()
      .p(
        'AgLAZQgCgDAEgCIAVgLQAKgFgFgIQgEgHgKgCIgXAMQgEABgCgDQgCgDAEgCIAigSQAEgCABAEQACADgEADIgDABQALADAEAIQAHAOgPAIIgWALIgCABQgBAAAAAAQgBgBAAAAQgBAAAAgBQAAAAgBgBg',
      );
    this.shape_111.setTransform(82.4398, -42.407, 2.491, 2.4932);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f('#58595B')
      .s()
      .p(
        'AgbASQgCgEAEgCIAfgUQAEgCACAEQACADgDACIggAUIgCABQgBAAAAAAQAAAAgBgBQAAAAgBAAQAAgBgBAAgAAUgLIgBAAQgCgEAEgDQAEgCACAEIABAAQABAEgDACIAAABIgDAAQAAAAgBAAQAAAAgBAAQAAAAAAgBQgBAAAAgBg',
      );
    this.shape_112.setTransform(80.1682, -51.7783, 2.491, 2.4932);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f('#58595B')
      .s()
      .p(
        'AgHAgIgBgDIAHgZIgKgCIgKAHQgCACgDgDQgCgDACgDIAugiQADgDACADQADADgDADIgcAXIAbADIADACQADADgEACIgDABIgRgDIgGAaIgCACIgCABQAAAAgBAAQAAAAAAAAQgBAAAAgBQgBAAAAgBg',
      );
    this.shape_113.setTransform(73.4086, -58.5549, 2.491, 2.4932);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f('#58595B')
      .s()
      .p(
        'AgBAcQgDgCADgEIAQgRQAHgHgGgHQgGgFgKABIgTASQgCADgEgDQgCgCACgDIAagbQAEgDACADQADACgDAEIgCACQALgBAGAHQAGAFgBAHQAAAGgFAFIgSASIgDABIgCgBg',
      );
    this.shape_114.setTransform(64.4152, -66.7707, 2.491, 2.4932);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f('#58595B')
      .s()
      .p(
        'AgUAaQgDgDADgDIAXgdQACgEADADQAEADgDADIgXAdQgBAAAAABQgBAAAAAAQAAABgBAAQAAAAgBAAIgCgBgAAOgRIAAAAQgDgDACgDIAAgBQADgEAEAEIAAAAQAEADgDADIAAABQgBAAAAABQAAAAgBAAQAAAAgBABQAAAAAAAAIgEgCg',
      );
    this.shape_115.setTransform(59.6457, -74.7605, 2.491, 2.4932);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f('#58595B')
      .s()
      .p(
        'AAEAlQgEgCACgEIAOgUQAGgJgIgFQgHgFgKAEIgOAWQgDADgDgCQgDgCACgEIAfgwQACgDADACQAEACgCAEIgNATQAMgCAGAFQAGAEABAGQABAGgEAGIgOAWQAAAAgBABQAAAAgBAAQAAABgBAAQAAAAAAAAIgCgBg',
      );
    this.shape_116.setTransform(50.1147, -80.3588, 2.491, 2.4932);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f('#58595B')
      .s()
      .p(
        'AgWAhQgEgCACgDIAWguIgRgIQgDgBABgDQABgEAEACIAoATQADABgBADQgCAFgDgCIgRgIIgVAuQAAAAgBABQAAAAAAAAQgBABAAAAQgBAAAAAAIgCgBg',
      );
    this.shape_117.setTransform(42.4937, -87.7762, 2.491, 2.4932);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f('#58595B')
      .s()
      .p(
        'AgIAgQgEgBABgEIAPg3QABgFAEACQAEABgBAEIgPA3QgBABAAABQAAAAgBABQAAAAgBAAQAAAAgBAAIgBAAg',
      );
    this.shape_118.setTransform(26.2021, -92.1911, 2.491, 2.4932);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f('#58595B')
      .s()
      .p(
        'AALAZQgEgBABgEIABgCQgJAFgIgCQgGgBgEgEQgDgFABgGQACgNAUAEIAKACIABgBQABgLgLgCQgEgBgHABIgCAAQAAAAgBgBQAAAAgBgBQAAAAAAgBQAAAAAAgBQAAgBAAAAQAAAAABgBQAAAAABgBQAAAAABAAQAIgCAHACQAJABAEAHQADAFgBAHIgFAYQAAAEgDAAIgCAAgAgMAGQgBAHAJACQAHABAHgFIABgIIgJgCIgFAAQgIAAgBAFg',
      );
    this.shape_119.setTransform(16.5184, -91.618, 2.491, 2.4932);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f('#58595B')
      .s()
      .p(
        'AAPAYQgEAAABgEIABgYQABgLgLAAQgGgBgIAJIgBAaQAAADgEAAQgEAAAAgEIACglQAAgEAEAAQAEAAAAAEIAAAEQAIgIAIAAQAHABAEAFQAEAFAAAIIgBAYQAAABAAABQAAABgBAAQAAABgBAAQAAAAgBAAIgCAAg',
      );
    this.shape_120.setTransform(4.4158, -93.2386, 2.491, 2.4932);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f('#58595B')
      .s()
      .p(
        'AgOATQgHgGgBgLQgBgKAGgHQAFgHALgBQAJgBAHAGQAHAGABALQABAKgGAHQgFAHgLABIgCAAQgIAAgGgFgAgBgPQgGAAgDAEQgFAFABAHQACAQANgBQAGAAAEgEQAEgFAAgHQgCgPgNAAIgBAAg',
      );
    this.shape_121.setTransform(-8.7793, -92.9496, 2.491, 2.4932);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f('#58595B')
      .s()
      .p(
        'AACAdIgGglQgBgEAEgBQADgBABAEIAHAlQAAAEgDABIgCAAQgBAAAAAAQgBAAAAgBQgBAAAAgBQAAAAAAgBgAgJgaQgBgEAFgBIABAAQAEgBAAAEIAAABQABAEgEABIAAAAIgCABQgDAAgBgFg',
      );
    this.shape_122.setTransform(-18.4042, -93.8823, 2.491, 2.4932);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics
      .f('#58595B')
      .s()
      .p(
        'AgDASIgIgaIgGACQAAAAAAAAQgBAAAAgBQAAAAAAAAQgBAAAAgBIABgBIAIgPIABgBQABAAAAAAQAAAAABAAQAAAAAAAAQABAAAAABIABAHIAJgDQAEgBABAEQABADgEABIgJADIAGAZQACAFAGgBIAFgDQABAAAAAAQABAAAAAAQAAABABAAQAAABAAABQABAAAAABQAAAAgBABQAAAAAAAAQAAABgBAAQgCADgEABIgFAAQgIAAgCgIg',
      );
    this.shape_123.setTransform(-24.3462, -91.2021, 2.491, 2.4932);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f('#58595B')
      .s()
      .p(
        'AgQAQQgFgNATgHIAKgEIgBAAQgEgLgKAFQgFABgFAFIgBABQgBAAgBAAQAAAAgBgBQAAAAgBAAQAAgBgBAAQAAgBAAAAQAAgBAAAAQAAgBAAAAQABgBAAAAQAGgGAIgDQAIgDAGADQAGADADAGIAJAXQACAEgFABQgEACgBgEIgBgCQgCAIgLAFIgGABQgIAAgEgJgAABABQgMAFADAGQACAHAIgDQAIgDADgJIgDgGg',
      );
    this.shape_124.setTransform(-33.7041, -86.6882, 2.491, 2.4932);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f('#58595B')
      .s()
      .p(
        'AAAASIgNgYIgGADQAAAAAAAAQgBAAAAAAQAAAAgBAAQAAAAAAgBQAAAAAAAAQgBAAAAgBQAAAAABAAQAAAAAAgBIAFgQQAAAAAAAAQABgBAAAAQAAAAAAAAQAAAAAAAAIACAAIAEAHIAJgFQAAAAABgBQAAAAABAAQAAABABAAQAAABAAABQABABAAAAQAAABAAAAQAAABgBAAQAAABgBAAIgIAFIAMAXQACAFAFgDIAFgDQABAAAAAAQABAAABAAQAAAAABAAQAAABAAAAIAAAEIgGAFQgEACgEAAQgGAAgCgGg',
      );
    this.shape_125.setTransform(-42.8987, -83.7473, 2.491, 2.4932);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f('#58595B')
      .s()
      .p(
        'AgCAbQgGgCgEgGIgPgUQgBgEACgCQAEgCACADIAOATQAGAJAHgFQAHgEABgLIgPgWQgCgEADgBQACgDADAEIAWAfQACADgDACIgDABIgDgCIgCgDQgCALgHAFQgFADgEAAIgDAAg',
      );
    this.shape_126.setTransform(-52.1387, -77.8564, 2.491, 2.4932);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics
      .f('#58595B')
      .s()
      .p(
        'AAOAiIgngrQgDgDADgDQADgDADADIACACQAAgJAGgGQAHgGAIAAQAJAAAHAIQAIAIgBAKQAAAIgGAGQgHAFgJAAIAPARQADADgDADIgDABIgDgBgAgGgWQgGAFAAAKIAMANQAJAAAFgFQAMgJgMgMQgFgGgGAAQgFAAgEAEg',
      );
    this.shape_127.setTransform(-63.4208, -66.3704, 2.491, 2.4932);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f('#58595B')
      .s()
      .p(
        'AgFAlIgegXQgEgDADgDQADgDADACIADACQgDgJAFgHQAGgIAKADQgEgLAGgIQAFgGAGAAQAGAAAGAEIAUAQQAEACgDAEQgDADgDgDIgTgOQgJgHgFAHQgFAHAFAJIAUAPQADACgDAEQgBADgEgCIgTgOQgIgHgGAHQgEAFADAKIAVAQQACADgCADQAAAAAAABQAAAAAAABQAAAAgBAAQAAAAgBAAIgDgBg',
      );
    this.shape_128.setTransform(-74.1811, -55.8577, 2.491, 2.4932);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f('#58595B')
      .s()
      .p(
        'AgJAUQgKgEgDgIQgDgIAFgJQAFgKAIgDQAIgCAKAEQAJAGADAIQADAHgFAKQgEAJgJACIgHACQgEAAgGgEgAgGgOQgFADgCAFQgDAFABAEQACAGAHAEQAHAEAGgDQAFgCADgEQACgGgBgEQgCgGgHgFQgFgCgCAAIgGABg',
      );
    this.shape_129.setTransform(-83.0334, -42.1501, 2.491, 2.4932);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics
      .f('#58595B')
      .s()
      .p(
        'AgJAcQgOgEgFgMQgGgLAEgMQADgKAJgHQAAgBABAAQAAAAAAAAQABAAABAAQAAAAABAAQABAAAAAAQABABAAAAQAAABAAABQAAAAAAABIgBACQgGAGgDAIQgEAKAFAIQAFAIAKAEQAJADAIgEQAJgEADgLQADgFgBgLIAAgBQABgEADABQABAAAAABQAAAAABAAQAAABAAAAQAAABABAAQACAMgDAIQgEAOgLAFQgHADgHAAQgEAAgHgCg',
      );
    this.shape_130.setTransform(-89.9221, -30.7252, 2.491, 2.4932);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_20 },
              { t: this.shape_19 },
              { t: this.shape_18 },
              { t: this.shape_17 },
              { t: this.shape_16 },
              { t: this.shape_15 },
              { t: this.shape_14 },
              { t: this.shape_13 },
              { t: this.shape_12 },
              { t: this.shape_11 },
              { t: this.shape_10 },
              { t: this.shape_9 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_32 },
              { t: this.shape_31 },
              { t: this.shape_30 },
              { t: this.shape_29 },
              { t: this.shape_28 },
              { t: this.shape_27 },
              { t: this.shape_26 },
              { t: this.shape_25 },
              { t: this.shape_24 },
              { t: this.shape_23 },
              { t: this.shape_22 },
              { t: this.shape_21 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_42 },
              { t: this.shape_41 },
              { t: this.shape_40 },
              { t: this.shape_39 },
              { t: this.shape_38 },
              { t: this.shape_37 },
              { t: this.shape_36 },
              { t: this.shape_35 },
              { t: this.shape_34 },
              { t: this.shape_33 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_58 },
              { t: this.shape_57 },
              { t: this.shape_56 },
              { t: this.shape_55 },
              { t: this.shape_54 },
              { t: this.shape_53 },
              { t: this.shape_52 },
              { t: this.shape_51 },
              { t: this.shape_50 },
              { t: this.shape_49 },
              { t: this.shape_48 },
              { t: this.shape_47 },
              { t: this.shape_46 },
              { t: this.shape_45 },
              { t: this.shape_44 },
              { t: this.shape_43 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_69 },
              { t: this.shape_68 },
              { t: this.shape_67 },
              { t: this.shape_66 },
              { t: this.shape_65 },
              { t: this.shape_64 },
              { t: this.shape_63 },
              { t: this.shape_62 },
              { t: this.shape_61 },
              { t: this.shape_60 },
              { t: this.shape_59 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_77 },
              { t: this.shape_76 },
              { t: this.shape_75 },
              { t: this.shape_74 },
              { t: this.shape_73 },
              { t: this.shape_72 },
              { t: this.shape_71 },
              { t: this.shape_70 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_91 },
              { t: this.shape_90 },
              { t: this.shape_89 },
              { t: this.shape_88 },
              { t: this.shape_87 },
              { t: this.shape_86 },
              { t: this.shape_85 },
              { t: this.shape_84 },
              { t: this.shape_83 },
              { t: this.shape_82 },
              { t: this.shape_81 },
              { t: this.shape_80 },
              { t: this.shape_79 },
              { t: this.shape_78 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_109 },
              { t: this.shape_108 },
              { t: this.shape_107 },
              { t: this.shape_106 },
              { t: this.shape_105 },
              { t: this.shape_104 },
              { t: this.shape_103 },
              { t: this.shape_102 },
              { t: this.shape_101 },
              { t: this.shape_100 },
              { t: this.shape_99 },
              { t: this.shape_98 },
              { t: this.shape_97 },
              { t: this.shape_96 },
              { t: this.shape_95 },
              { t: this.shape_94 },
              { t: this.shape_93 },
              { t: this.shape_92 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_130 },
              { t: this.shape_129 },
              { t: this.shape_128 },
              { t: this.shape_127 },
              { t: this.shape_126 },
              { t: this.shape_125 },
              { t: this.shape_124 },
              { t: this.shape_123 },
              { t: this.shape_122 },
              { t: this.shape_121 },
              { t: this.shape_120 },
              { t: this.shape_119 },
              { t: this.shape_118 },
              { t: this.shape_117 },
              { t: this.shape_116 },
              { t: this.shape_115 },
              { t: this.shape_114 },
              { t: this.shape_113 },
              { t: this.shape_112 },
              { t: this.shape_111 },
              { t: this.shape_110 },
            ],
          },
          1,
        )
        .wait(2),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-98, -105, 193, 82.1);

  (lib.BackLabel = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ag0g7IAQgCIARB4IgTADgAgYATQAPgTAQgZIAUgFQgNAXgQAWQAbASAbAOIgZAFQgcgSgXgPg',
      );
    this.shape.setTransform(14.15, 61.7);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAgQgNgLAAgTQAAgRAMgNQAMgMARgBIANABIANADIABARQgOgGgKAAQgKAAgJAIQgHAJABAKQAAANAJAGQAHAIAPgBQAKgBAOgGIABAPQgNAGgOABIgFAAQgSAAgMgKg',
      );
    this.shape_1.setTransform(4.3, 64.2753);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AALAmIgEgEIgJADQgKAEgFgBQgKAAgGgHQgGgGABgIQABgIAGgFQAIgGALgBIAWgGIAAgEQABgOgPgCQgOAAgPALIACgRQALgKASACQANABAIAHIAFAGQADAEAAADIgBAvQAAABAAABQAAABABAAQAAABABAAQAAAAABAAQAFAAAGgEIAAAKIgLAFIgIABQgFgBgFgEgAgCAEQgJACgEAEQgFADAAAFQgBAEAEAEQAEAEAFAAQAIABAIgGIABgYg',
      );
    this.shape_2.setTransform(-4.5571, 64.2902);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgKA/QgIgBgLgEQgJgDgFgFIAZhyIAQADIgJAvQALgFAMACQAQACAJAOQAJAMgCARQgCAUgPAKQgLAHgOAAIgMgCgAgOAAIgJArQAKAEAJACQALADAJgHQAJgGABgMQACgLgGgKQgGgHgKgCIgFAAQgHAAgIADg',
      );
    this.shape_3.setTransform(-13.9068, 60.8698);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.BackLabel,
    new cjs.Rectangle(-18.3, 54.4, 37.7, 14.199999999999996),
    null,
  );

  (lib.gameInfo = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    this.isSingleFrame = false;
    // timeline functions:
    this.frame_0 = function () {
      if (this.isSingleFrame) {
        return;
      }
      if (this.totalFrames == 1) {
        this.isSingleFrame = true;
      }
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

    // text
    this.skillsText = new cjs.Text(
      'Addition',
      "18px 'Gill Sans MT'",
      '#003399',
    );
    this.skillsText.name = 'skillsText';
    this.skillsText.lineHeight = 21;
    this.skillsText.lineWidth = 187;
    this.skillsText.parent = this;
    this.skillsText.setTransform(-62, 30.05);

    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#003399')
      .s()
      .p(
        'AgKAmQgFgFAAgGQAAgHAFgEQAFgFAFAAQAHAAAEAFQAFAEAAAHQAAAGgFAFQgEAEgHAAQgFAAgFgEgAgKgOQgFgFAAgHQAAgGAFgFQAFgEAFAAQAHAAAEAEQAFAFAAAGQAAAHgFAFQgEAEgHAAQgFAAgFgEg',
      );
    this.shape.setTransform(-72.475, 42.725);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f('#003399').s().p('AgMA9IAAh6IAZAAIAAB6g');
    this.shape_1.setTransform(-77.35, 40.65);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics.f('#003399').s().p('AgMA9IAAh6IAZAAIAAB6g');
    this.shape_2.setTransform(-82.25, 40.65);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#003399')
      .s()
      .p(
        'AgMA+IAAhSIAZAAIAABSgAgJglQgEgEAAgGQAAgGAEgEQAEgEAFAAQAGAAAEAEQAEAEAAAGQAAAGgEAEQgEAFgGAAQgFAAgEgFg',
      );
    this.shape_3.setTransform(-87.175, 40.575);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#003399')
      .s()
      .p('AANA9IgfgpIAAAAIAAApIgaAAIAAh6IAaAAIAABQIAAAAIAfgnIAfAAIghAnIAiAqg');
    this.shape_4.setTransform(-93.875, 40.65);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#003399')
      .s()
      .p(
        'AgrAzIAAgaQAMAIAJAEQAKAEAKAAQASAAgBgMQABgEgEgDQgDgDgNgFIgWgJQgIgFgGgHQgGgHAAgNQAAgQANgJQAMgKAVAAQATAAAWAJIAAAZQgYgLgOAAQgHAAgGACQgEADAAAFQgBADAEAEQAEADAMAEQAOAGAIAEQAIAEAGAHQAGAIAAAMQAAARgNAKQgNAKgVAAQgWAAgVgMg',
      );
    this.shape_5.setTransform(-104.85, 40.65);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#333333')
      .s()
      .p(
        'AgKAmQgFgFAAgGQAAgHAFgEQAFgFAFAAQAHAAAEAFQAFAEAAAHQAAAGgFAFQgEAEgHAAQgFAAgFgEgAgKgOQgFgFAAgHQAAgGAFgFQAFgEAFAAQAHAAAEAEQAFAFAAAGQAAAHgFAFQgEAEgHAAQgFAAgFgEg',
      );
    this.shape_6.setTransform(-21.075, 13.525);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#333333')
      .s()
      .p(
        'AgdAfQgOgLAAgTQAAgTANgMQAMgMASAAQATAAANANQAMAMgBAVIg7AAQABAMAHAFQAIAHALgBQAOABARgMIAAAQQgPALgWAAQgVAAgNgMgAgPgIIAjAAQgCgSgQAAQgPAAgCASg',
      );
    this.shape_7.setTransform(-28.449, 13.45);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#333333')
      .s()
      .p(
        'AAxAqIAAgvQAAgJgFgFQgDgFgIAAQgLAAgJAOIAAA0IgZAAIAAgwQAAgJgFgEQgEgFgHAAQgKAAgKAMIAAA2IgaAAIAAhSIAaAAIAAALQANgMAQAAQAUAAAIARQAQgRARAAQAPAAAJAIQAJAJAAAOIAAA0g',
      );
    this.shape_8.setTransform(-42.05, 13.375);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#333333')
      .s()
      .p(
        'AgMA+IAAhSIAZAAIAABSgAgJglQgEgEAAgGQAAgGAEgEQAEgEAFAAQAGAAAEAEQAEAEAAAGQAAAGgEAEQgEAFgGAAQgFAAgEgFg',
      );
    this.shape_9.setTransform(-53.175, 11.375);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#333333')
      .s()
      .p(
        'AgNAvQgIgHAAgQIAAgiIgMAAIAAgFIAignIADAAIAAAaIAeAAIAAASIgeAAIAAAhQAAAGADAEQAEADAGAAQAIAAAJgFIAAATQgMAFgMAAQgOAAgJgIg',
      );
    this.shape_10.setTransform(-59.275, 12.225);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics.f('#333333').s().p('AgMA+IAAh6IAZAAIAAB6g');
    this.shape_11.setTransform(-70.35, 11.45);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#333333')
      .s()
      .p(
        'AAGAiQgNAJgOAAQgJAAgHgGQgHgGAAgIQAAgLAHgGQAHgHAjgKQAAgOgOAAQgQAAgOAOIAAgVQAQgKATAAQAjAAAAAZIAAAlQAAAFAEABQADgBAHgEIAAAPQgNAHgMAAQgMAAgCgJgAgMAJQgFAEAAAGQAAAEACACQADACADAAQAIABAGgHIAAgUQgNAFgEADg',
      );
    this.shape_12.setTransform(-77.275, 13.45);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#333333')
      .s()
      .p(
        'AgNAvQgIgHAAgQIAAgiIgMAAIAAgFIAignIADAAIAAAaIAeAAIAAASIgeAAIAAAhQAAAGADAEQAEADAGAAQAIAAAJgFIAAATQgMAFgMAAQgOAAgJgIg',
      );
    this.shape_13.setTransform(-86.025, 12.225);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#333333')
      .s()
      .p(
        'AghAfQgNgMAAgTQAAgTANgMQAOgLATAAQAUAAANALQAOAMAAATQAAAVgOALQgOALgTAAQgTAAgOgMgAgNgTQgFAGAAANQAAAbASAAQATAAAAgbQAAgagTAAQgIgBgFAIg',
      );
    this.shape_14.setTransform(-95, 13.45);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#333333')
      .s()
      .p('AgOA+IAAhkIgtAAIAAgWIB3AAIAAAWIgtAAIAABkg');
    this.shape_15.setTransform(-103.875, 11.45);

    this.totalTime = new cjs.Text('', "18px 'Gill Sans MT'", '#333333');
    this.totalTime.name = 'totalTime';
    this.totalTime.lineHeight = 21;
    this.totalTime.lineWidth = 150;
    this.totalTime.parent = this;
    this.totalTime.setTransform(-9.5, 0.85);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.totalTime },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
            { t: this.skillsText },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.gameInfo,
    new cjs.Rectangle(-154, -1.1, 296.5, 54.1),
    null,
  );

  (lib.ButtonBG = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(102,102,102,0)')
      .s()
      .p(
        'Ao0I2QjrjqAAlMQAAlLDrjpQDqjrFKAAQFMAADpDrQDrDpAAFLQAAFMjrDqQjpDqlMAAQlKAAjqjqg',
      );

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-80, -80, 160, 160);

  (lib.ProgressStar = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      /* stop();*/
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(24));

    // outline
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .ls(['#CC0066', '#FF505A'], [0, 1], 0, 20, 0, -20)
      .ss(2, 1, 1)
      .p('AhQjHIChAAQAnAAAAAnIAAFBQAAAngnAAIihAAQgnAAAAgnIAAlBQAAgnAnAAg');
    this.shape.setTransform(48, 60);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(255,255,255,0)')
      .s()
      .p('AhQDIQgnAAAAgnIAAlBQAAgnAnAAIChAAQAnAAAAAnIAAFBQAAAngnAAg');
    this.shape_1.setTransform(48, 60);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .lf(['#CC0066', '#FF505A'], [0, 1], 0.1, 28.5, -0.1, -28.5)
      .s()
      .p(
        'AAACeIi4B/IBAjYIiziHIDggHIBLjTIBLDTIDhAHIizCHIBADYgACODgIgxikICJhpIisgEIg5ihIg6ChIisAEICJBpIgxCkICOhig',
      );
    this.shape_2.setTransform(49.95, 54.7);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .to({ state: [] }, 11)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [] }, 11)
        .wait(1),
    );

    // meter mask (mask)
    var mask = new cjs.Shape();
    mask._off = true;
    var mask_graphics_0 = new cjs.Graphics().p('Ah3DIIAAmPIDvAAIAAGPg');
    var mask_graphics_12 = new cjs.Graphics().p(
      'AABB4IiOBiIAxilIiJhoICsgFIA6ihIA5ChICsAFIiJBoIAxClg',
    );

    this.timeline.addTween(
      cjs.Tween.get(mask)
        .to({ graphics: mask_graphics_0, x: 48, y: 60 })
        .wait(11)
        .to({ graphics: null, x: 0, y: 0 })
        .wait(1)
        .to({ graphics: mask_graphics_12, x: 49.95, y: 55.35 })
        .wait(11)
        .to({ graphics: null, x: 0, y: 0 })
        .wait(1),
    );

    // meter fill
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .lf(['#999999', '#FFFFFF'], [0, 1], -16, -0.5, 15.9, -0.5)
      .s()
      .p('AifDIIAAmPIE/AAIAAGPg');
    this.shape_3.setTransform(48, 95);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .lf(['#FFFF22', '#F9BF34'], [0, 1], 30, 0, -30, 0)
      .s()
      .p('AkrBWIAAirIJXAAIAACrg');
    this.shape_4.setTransform(49.95, 81.325);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .lf(['#FFFF22', '#F9BF34'], [0, 1], 30, 0, -30, 0)
      .s()
      .p('AkrBmIAAjLIJXAAIAADLg');
    this.shape_5.setTransform(49.95, 79.7);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .lf(['#FFFF22', '#F9BF34'], [0, 1], 30, 0, -30, 0)
      .s()
      .p('AkrB3IAAjtIJXAAIAADtg');
    this.shape_6.setTransform(49.95, 78.075);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .lf(['#FFFF22', '#F9BF34'], [0, 1], 30, 0.1, -30, 0.1)
      .s()
      .p('AkrCHIAAkNIJXAAIAAENg');
    this.shape_7.setTransform(49.95, 76.45);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .lf(['#FFFF22', '#F9BF34'], [0, 1], 30, 0.1, -30, 0.1)
      .s()
      .p('AkrCXIAAktIJXAAIAAEtg');
    this.shape_8.setTransform(49.95, 74.825);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .lf(['#FFFF22', '#F9BF34'], [0, 1], 30, 0.1, -30, 0.1)
      .s()
      .p('AkrCoIAAlPIJXAAIAAFPg');
    this.shape_9.setTransform(49.95, 73.225);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .lf(['#FFFF22', '#F9BF34'], [0, 1], 30, 0.1, -30, 0.1)
      .s()
      .p('AkrC4IAAlvIJXAAIAAFvg');
    this.shape_10.setTransform(49.95, 71.575);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .lf(['#FFFF22', '#F9BF34'], [0, 1], 30, 0.1, -30, 0.1)
      .s()
      .p('AkrDIIAAmQIJXAAIAAGQg');
    this.shape_11.setTransform(49.95, 69.95);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .lf(['#FFFF22', '#F9BF34'], [0, 1], 30, 0.1, -30, 0.1)
      .s()
      .p('AkrDZIAAmxIJXAAIAAGxg');
    this.shape_12.setTransform(49.95, 68.325);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .lf(['#FFFF22', '#F9BF34'], [0, 1], 30, 0.2, -30, 0.2)
      .s()
      .p('AkrDpIAAnRIJXAAIAAHRg');
    this.shape_13.setTransform(49.95, 66.7);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .lf(['#FFFF22', '#F9BF34'], [0, 1], 30, 0.2, -30, 0.2)
      .s()
      .p('AkrD5IAAnxIJXAAIAAHxg');
    this.shape_14.setTransform(49.95, 65.075);

    var maskedShapeInstanceList = [
      this.shape_3,
      this.shape_4,
      this.shape_5,
      this.shape_6,
      this.shape_7,
      this.shape_8,
      this.shape_9,
      this.shape_10,
      this.shape_11,
      this.shape_12,
      this.shape_13,
      this.shape_14,
    ];

    for (
      var shapedInstanceItr = 0;
      shapedInstanceItr < maskedShapeInstanceList.length;
      shapedInstanceItr++
    ) {
      maskedShapeInstanceList[shapedInstanceItr].mask = mask;
    }

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }] })
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [] }, 1)
        .to({ state: [{ t: this.shape_4 }] }, 1)
        .to({ state: [{ t: this.shape_5 }] }, 1)
        .to({ state: [{ t: this.shape_6 }] }, 1)
        .to({ state: [{ t: this.shape_7 }] }, 1)
        .to({ state: [{ t: this.shape_8 }] }, 1)
        .to({ state: [{ t: this.shape_9 }] }, 1)
        .to({ state: [{ t: this.shape_10 }] }, 1)
        .to({ state: [{ t: this.shape_11 }] }, 1)
        .to({ state: [{ t: this.shape_12 }] }, 1)
        .to({ state: [{ t: this.shape_13 }] }, 1)
        .to({ state: [{ t: this.shape_14 }] }, 1)
        .to({ state: [] }, 1)
        .wait(1),
    );
    this.timeline.addTween(
      cjs.Tween.get(this.shape_3)
        .wait(1)
        .to({ y: 92 }, 0)
        .wait(1)
        .to({ y: 89 }, 0)
        .wait(1)
        .to({ y: 86 }, 0)
        .wait(1)
        .to({ y: 83 }, 0)
        .wait(1)
        .to({ y: 80 }, 0)
        .wait(1)
        .to({ y: 77 }, 0)
        .wait(1)
        .to({ y: 74 }, 0)
        .wait(1)
        .to({ y: 71 }, 0)
        .wait(1)
        .to({ y: 68 }, 0)
        .wait(1)
        .to({ y: 65 }, 0)
        .to({ _off: true }, 1)
        .wait(13),
    );

    // Layer_2
    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .lf(
        ['rgba(153,153,153,0.498)', 'rgba(204,204,204,0.498)'],
        [0, 1],
        0.2,
        4.4,
        -0.1,
        -4.3,
      )
      .s()
      .p('AAAAwIg3AnIAThCIg3gpIBFgBIAWhBIAXBBIBEABIg2ApIAUBCg');
    this.shape_15.setTransform(47.95, 58.625);

    this.timeline.addTween(
      cjs.Tween.get(this.shape_15).to({ _off: true }, 11).wait(13),
    );

    // bg
    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics.f('#FFFFFF').s().p('Ah3DIIAAmPIDvAAIAAGPg');
    this.shape_16.setTransform(48, 60);

    this.instance = new lib.star_silver('synched', 0);
    this.instance.setTransform(49.95, 55.9, 1, 1, 0, 0, 0, 0, -0.3);

    this.instance_1 = new lib.star_gold('synched', 0);
    this.instance_1.setTransform(49.95, 55.9, 1, 1, 0, 0, 0, 0, -0.3);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_16 }] })
        .to({ state: [{ t: this.instance }] }, 11)
        .to({ state: [{ t: this.instance_1 }] }, 12)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(20, 26.2, 60, 57);

  (lib.SSInfoPane = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    this.isSingleFrame = false;
    // timeline functions:
    this.frame_0 = function () {
      if (this.isSingleFrame) {
        return;
      }
      if (this.totalFrames == 1) {
        this.isSingleFrame = true;
      }
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

    // Layer 1
    this.badge = new lib.SkillSetBadge();
    this.badge.name = 'badge';
    this.badge.setTransform(-218, -238.9);

    this.g3Info = new lib.gameInfo();
    this.g3Info.name = 'g3Info';
    this.g3Info.setTransform(152.7, 93.3);

    this.g2Info = new lib.gameInfo();
    this.g2Info.name = 'g2Info';
    this.g2Info.setTransform(163.7, -58.65);

    this.g1Info = new lib.gameInfo();
    this.g1Info.name = 'g1Info';
    this.g1Info.setTransform(143.7, -207.65);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.g1Info },
            { t: this.g2Info },
            { t: this.g3Info },
            { t: this.badge },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.SSInfoPane,
    new cjs.Rectangle(-10.3, -208.8, 316.5, 355.1),
    null,
  );

  (lib.Button = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // back button
    this.back = new lib.BackLabel();
    this.back.name = 'back';
    this.back.setTransform(2.35, -93.7, 1, 1, 0, 0, 0, 2, -99.5);

    this.timeline.addTween(cjs.Tween.get(this.back).wait(1));

    // buttonBg
    this.buttonBg = new lib.ButtonBG('synched', 0);
    this.buttonBg.name = 'buttonBg';

    this.timeline.addTween(cjs.Tween.get(this.buttonBg).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Button,
    new cjs.Rectangle(-80, -80, 160, 160),
    null,
  );

  // stage content:
  (lib.FIMHub = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = false;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // frame
    this.errorText = new cjs.Text('', "10px 'Arial'", '#999999');
    this.errorText.name = 'errorText';
    this.errorText.textAlign = 'center';
    this.errorText.lineHeight = 11;
    this.errorText.lineWidth = 597;
    this.errorText.parent = this;
    this.errorText.setTransform(900.4, 10.05);

    this.shape = new cjs.Shape();
    this.shape.graphics
      .lf(
        [
          '#FFFFFF',
          '#FFFFFF',
          'rgba(255,255,255,0.012)',
          'rgba(255,255,255,0.004)',
        ],
        [0, 0, 0.992, 1],
        7.5,
        -6,
        -7.5,
        -6,
      )
      .s()
      .p('EAA7At8Ih2AAIAAhzMAAAhaEIB3AAMAAABb3g');
    this.shape.setTransform(594, 305.475);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .lf(['#FFFFFF', 'rgba(255,255,255,0.004)'], [0, 1], 6.1, -7.5, 6.1, 7.5)
      .s()
      .p('EAtAAA8MhZ9AAAIAAhxIgCAAIh4AAIAAgGMBdvAAAIAAB3g');
    this.shape_1.setTransform(300, 5.5);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .lf(['#FFFFFF', 'rgba(255,255,255,0.004)'], [0, 1], 0, 7.5, 0, -7.5)
      .s()
      .p('Egu3AA8IAAh3IB4AAMBZ/AAAIAAByIB4AAIAAAFg');
    this.shape_2.setTransform(299.975, 594);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .lf(['#FFFFFF', 'rgba(255,255,255,0.004)'], [0, 1], -7.5, 6, 7.5, 6)
      .s()
      .p('EgA7At8MAAAhb3IB3AAMAAABb3g');
    this.shape_3.setTransform(6, 294.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
            { t: this.errorText },
          ],
        })
        .wait(1),
    );

    // mainstage
    this.mainStage = new lib.MainStage();
    this.mainStage.name = 'mainStage';
    this.mainStage.setTransform(26.9, 8.8, 1, 1, 0, 0, 0, 26.9, 8.8);

    this.timeline.addTween(cjs.Tween.get(this.mainStage).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new lib.AnMovieClip();
  p.nominalBounds = new cjs.Rectangle(300, 279, 900.9000000000001, 321);
  // library properties:
  lib.properties = {
    id: 'E3D4E169DDB59C48A3B46AB2CE777800',
    width: 600,
    height: 600,
    fps: 24,
    color: '#FFFFFF',
    opacity: 1.0,
    manifest: [],
    preloads: [],
  };

  // bootstrap callback support:

  (lib.Stage = function (canvas) {
    createjs.Stage.call(this, canvas);
  }).prototype = p = new createjs.Stage();

  p.setAutoPlay = function (autoPlay) {
    this.tickEnabled = autoPlay;
  };
  p.play = function () {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
  };
  p.stop = function (ms) {
    if (ms) this.seek(ms);
    this.tickEnabled = false;
  };
  p.seek = function (ms) {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
  };
  p.getDuration = function () {
    return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
  };

  p.getTimelinePosition = function () {
    return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
  };

  an.bootcompsLoaded = an.bootcompsLoaded || [];
  if (!an.bootstrapListeners) {
    an.bootstrapListeners = [];
  }

  an.bootstrapCallback = function (fnCallback) {
    an.bootstrapListeners.push(fnCallback);
    if (an.bootcompsLoaded.length > 0) {
      for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
        fnCallback(an.bootcompsLoaded[i]);
      }
    }
  };

  an.compositions = an.compositions || {};
  an.compositions['E3D4E169DDB59C48A3B46AB2CE777800'] = {
    getStage: function () {
      return exportRoot.stage;
    },
    getLibrary: function () {
      return lib;
    },
    getSpriteSheet: function () {
      return ss;
    },
    getImages: function () {
      return img;
    },
  };

  an.compositionLoaded = function (id) {
    an.bootcompsLoaded.push(id);
    for (var j = 0; j < an.bootstrapListeners.length; j++) {
      an.bootstrapListeners[j](id);
    }
  };

  an.getComposition = function (id) {
    return an.compositions[id];
  };

  an.makeResponsive = function (
    isResp,
    respDim,
    isScale,
    scaleType,
    domContainers,
    stage,
  ) {
    var lastW,
      lastH,
      lastS = 1;
    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();
    function resizeCanvas() {
      var w = lib.properties.width,
        h = lib.properties.height;
      var iw = window.innerWidth,
        ih = window.innerHeight;
      var pRatio = window.devicePixelRatio || 1,
        xRatio = iw / w,
        yRatio = ih / h,
        sRatio = 1;
      if (isResp) {
        if (
          (respDim == 'width' && lastW == iw) ||
          (respDim == 'height' && lastH == ih)
        ) {
          sRatio = lastS;
        } else if (!isScale) {
          if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 1) {
          sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 2) {
          sRatio = Math.max(xRatio, yRatio);
        }
      }
      domContainers[0].width = w * pRatio * sRatio;
      domContainers[0].height = h * pRatio * sRatio;
      domContainers.forEach(function (container) {
        container.style.width = w * sRatio + 'px';
        container.style.height = h * sRatio + 'px';
      });
      stage.scaleX = pRatio * sRatio;
      stage.scaleY = pRatio * sRatio;
      lastW = iw;
      lastH = ih;
      lastS = sRatio;
      stage.tickOnUpdate = false;
      stage.update();
      stage.tickOnUpdate = true;
    }
  };
  an.handleSoundStreamOnTick = function (event) {
    if (!event.paused) {
      var stageChild = stage.getChildAt(0);
      if (!stageChild.paused || stageChild.ignorePause) {
        stageChild.syncStreamSounds();
      }
    }
  };
  an.handleFilterCache = function (event) {
    if (!event.paused) {
      var target = event.target;
      if (target) {
        if (target.filterCacheList) {
          for (var index = 0; index < target.filterCacheList.length; index++) {
            var cacheInst = target.filterCacheList[index];
            if (
              cacheInst.startFrame <= target.currentFrame &&
              target.currentFrame <= cacheInst.endFrame
            ) {
              cacheInst.instance.cache(
                cacheInst.x,
                cacheInst.y,
                cacheInst.w,
                cacheInst.h,
              );
            }
          }
        }
      }
    }
  };
}
